/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

import { Route as rootRouteImport } from "./root";
import { Route as LoginRouteImport } from "./user/pages/login";
import { Route as PanelRouteImport } from "./user/pages/_panel";
import { Route as MeetRouteImport } from "./../modules/meet/user/pages/_meet";
import { Route as AdminPanelRouteImport } from "./admin/pages/_panel";
import { Route as PanelSettingsRouteImport } from "./user/pages/_panel/_settings";
import { Route as PanelRecognitionRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition";
import { Route as PanelProfileRouteImport } from "./../modules/profile/user/pages/_panel/_profile";
import { Route as PanelPerformanceRouteImport } from "./../modules/performance/user/pages/_panel/_performance";
import { Route as PanelNewsRouteImport } from "./../modules/news/user/pages/_panel/_news";
import { Route as PanelMessengerRouteImport } from "./../modules/messenger/user/pages/_panel/_messenger";
import { Route as PanelMeetRouteImport } from "./../modules/meet/user/pages/_panel/_meet";
import { Route as PanelHandbookRouteImport } from "./../modules/handbook/user/pages/_panel/_handbook";
import { Route as PanelCoreRouteImport } from "./user/pages/_panel/_core";
import { Route as PanelChartRouteImport } from "./../modules/chart/user/pages/_panel/_chart";
import { Route as PanelApplicationRouteImport } from "./../modules/application/user/pages/_panel/_application";
import { Route as PanelCoreIndexRouteImport } from "./user/pages/_panel/_core/index";
import { Route as AdminPanelSettingsRouteImport } from "./admin/pages/_panel/_settings";
import { Route as AdminPanelReportRouteImport } from "./../modules/report/admin/pages/_panel/_report";
import { Route as AdminPanelRecognitionRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition";
import { Route as AdminPanelProfileRouteImport } from "./../modules/profile/admin/pages/_panel/_profile";
import { Route as AdminPanelPerformanceRouteImport } from "./../modules/performance/admin/pages/_panel/_performance";
import { Route as AdminPanelNewsRouteImport } from "./../modules/news/admin/pages/_panel/_news";
import { Route as AdminPanelMoodRouteImport } from "./../modules/mood/admin/pages/_panel/_mood";
import { Route as AdminPanelMessengerRouteImport } from "./../modules/messenger/admin/pages/_panel/_messenger";
import { Route as AdminPanelHandbookRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook";
import { Route as AdminPanelCoreRouteImport } from "./admin/pages/_panel/_core";
import { Route as AdminPanelChartRouteImport } from "./../modules/chart/admin/pages/_panel/_chart";
import { Route as AdminPanelApplicationRouteImport } from "./../modules/application/admin/pages/_panel/_application";
import { Route as MeetDotmeetCodeRouteImport } from "./../modules/meet/user/pages/_meet.meet/$code";
import { Route as AdminPanelCoreIndexRouteImport } from "./admin/pages/_panel/_core/index";
import { Route as PanelSettingsDotsettingsIndexRouteImport } from "./user/pages/_panel/_settings.settings/index";
import { Route as PanelRecognitionDotrecognitionIndexRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/index";
import { Route as PanelPerformanceDotperformanceIndexRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/index";
import { Route as PanelNewsDotnewsIndexRouteImport } from "./../modules/news/user/pages/_panel/_news.news/index";
import { Route as PanelMessengerDotmessengerIndexRouteImport } from "./../modules/messenger/user/pages/_panel/_messenger.messenger/index";
import { Route as ApplicationDotrequestsDotuuidDotuuidRouteImport } from "./../modules/application/user/pages/application.requests.uuid.$uuid";
import { Route as PanelSettingsDotsettingsNotificationsRouteImport } from "./user/pages/_panel/_settings.settings/notifications";
import { Route as PanelSettingsDotsettingsLocaleRouteImport } from "./user/pages/_panel/_settings.settings/locale";
import { Route as PanelProfileDotprofileMeRouteImport } from "./../modules/profile/user/pages/_panel/_profile.profile/me";
import { Route as PanelProfileDotprofileIdRouteImport } from "./../modules/profile/user/pages/_panel/_profile.profile/$id";
import { Route as PanelNewsDotnewsIdRouteImport } from "./../modules/news/user/pages/_panel/_news.news/$id";
import { Route as PanelMessengerDotmessengerIdRouteImport } from "./../modules/messenger/user/pages/_panel/_messenger.messenger/$id";
import { Route as AdminPanelSettingsDotsettingsIndexRouteImport } from "./admin/pages/_panel/_settings.settings/index";
import { Route as AdminPanelProfileDotprofileIndexRouteImport } from "./../modules/profile/admin/pages/_panel/_profile.profile/index";
import { Route as AdminPanelNewsDotnewsIndexRouteImport } from "./../modules/news/admin/pages/_panel/_news.news/index";
import { Route as AdminPanelMoodDotmoodIndexRouteImport } from "./../modules/mood/admin/pages/_panel/_mood.mood/index";
import { Route as AdminPanelHandbookDothandbookIndexRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook.handbook/index";
import { Route as AdminPanelChartDotchartIndexRouteImport } from "./../modules/chart/admin/pages/_panel/_chart.chart/index";
import { Route as PanelRecognitionDotrecognitionTopIndexRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/top/index";
import { Route as PanelRecognitionDotrecognitionRewardsIndexRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/rewards/index";
import { Route as PanelPerformanceDotperformanceReviewsIndexRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/reviews/index";
import { Route as PanelPerformanceDotperformanceObjectivesIndexRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/objectives/index";
import { Route as PanelPerformanceDotperformanceCheckinsIndexRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/checkins/index";
import { Route as PanelNewsDotnewsCategoriesIndexRouteImport } from "./../modules/news/user/pages/_panel/_news.news/categories/index";
import { Route as PanelMeetDotmeetSessionsIndexRouteImport } from "./../modules/meet/user/pages/_panel/_meet.meet/sessions/index";
import { Route as PanelHandbookDothandbookEntriesIndexRouteImport } from "./../modules/handbook/user/pages/_panel/_handbook.handbook/entries/index";
import { Route as PanelApplicationDotapplicationRequestsIndexRouteImport } from "./../modules/application/user/pages/_panel/_application.application/requests/index";
import { Route as PanelApplicationDotapplicationApplicationsIndexRouteImport } from "./../modules/application/user/pages/_panel/_application.application/applications/index";
import { Route as AdminPanelSettingsDotsettingsUsersRouteImport } from "./admin/pages/_panel/_settings.settings/users";
import { Route as AdminPanelSettingsDotsettingsRecognitionRouteImport } from "./../modules/recognition/admin/pages/_panel/_settings.settings/recognition";
import { Route as AdminPanelSettingsDotsettingsProfileRouteImport } from "./../modules/profile/admin/pages/_panel/_settings.settings/profile";
import { Route as AdminPanelSettingsDotsettingsPerformanceRouteImport } from "./../modules/performance/admin/pages/_panel/_settings.settings/performance";
import { Route as AdminPanelSettingsDotsettingsNotificationsRouteImport } from "./admin/pages/_panel/_settings.settings/notifications";
import { Route as AdminPanelSettingsDotsettingsNewsRouteImport } from "./../modules/news/admin/pages/_panel/_settings.settings/news";
import { Route as AdminPanelSettingsDotsettingsMoodRouteImport } from "./../modules/mood/admin/pages/_panel/_settings.settings/mood";
import { Route as AdminPanelProfileDotprofileRequestsRouteImport } from "./../modules/profile/admin/pages/_panel/_profile.profile/requests";
import { Route as AdminPanelNewsDotnewsCreateRouteImport } from "./../modules/news/admin/pages/_panel/_news.news/create";
import { Route as AdminPanelNewsDotnewsIdRouteImport } from "./../modules/news/admin/pages/_panel/_news.news/$id";
import { Route as AdminPanelChartDotchartTypeRouteImport } from "./../modules/chart/admin/pages/_panel/_chart.chart/$type";
import { Route as PanelRecognitionDotrecognitionTransactionsTransfersRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/transactions/transfers";
import { Route as PanelRecognitionDotrecognitionTransactionsRewardsRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/transactions/rewards";
import { Route as PanelRecognitionDotrecognitionTopIdRouteImport } from "./../modules/recognition/user/pages/_panel/_recognition.recognition/top/$id";
import { Route as PanelPerformanceDotperformanceObjectivesCreateRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/objectives/create";
import { Route as PanelPerformanceDotperformanceObjectivesIdRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/objectives/$id";
import { Route as PanelPerformanceDotperformanceCheckinsCreateRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/checkins/create";
import { Route as PanelPerformanceDotperformanceCheckinsIdRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/checkins/$id";
import { Route as PanelHandbookDothandbookEntriesIdRouteImport } from "./../modules/handbook/user/pages/_panel/_handbook.handbook/entries/$id";
import { Route as PanelChartDotchartChartsTypeRouteImport } from "./../modules/chart/user/pages/_panel/_chart.chart/charts/$type";
import { Route as PanelApplicationDotapplicationRequestsIdRouteImport } from "./../modules/application/user/pages/_panel/_application.application/requests/$id";
import { Route as AdminPanelSettingsDotsettingsRolesIndexRouteImport } from "./admin/pages/_panel/_settings.settings/roles/index";
import { Route as AdminPanelSettingsDotsettingsEntityIndexRouteImport } from "./admin/pages/_panel/_settings.settings/entity/index";
import { Route as AdminPanelReportDotreportReportsIndexRouteImport } from "./../modules/report/admin/pages/_panel/_report.report/reports/index";
import { Route as AdminPanelRecognitionDotrecognitionValuesIndexRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/values/index";
import { Route as AdminPanelRecognitionDotrecognitionTransactionsIndexRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/transactions/index";
import { Route as AdminPanelRecognitionDotrecognitionRewardsIndexRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/rewards/index";
import { Route as AdminPanelRecognitionDotrecognitionPeriodsIndexRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/periods/index";
import { Route as AdminPanelRecognitionDotrecognitionPeriodReportsIndexRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/period-reports/index";
import { Route as AdminPanelPerformanceDotperformanceTagsIndexRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/tags/index";
import { Route as AdminPanelNewsDotnewsCommentsIndexRouteImport } from "./../modules/news/admin/pages/_panel/_news.news/comments/index";
import { Route as AdminPanelNewsDotnewsCategoriesIndexRouteImport } from "./../modules/news/admin/pages/_panel/_news.news/categories/index";
import { Route as AdminPanelMessengerDotmessengerGroupsIndexRouteImport } from "./../modules/messenger/admin/pages/_panel/_messenger.messenger/groups/index";
import { Route as AdminPanelHandbookDothandbookEntriesIndexRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook.handbook/entries/index";
import { Route as AdminPanelHandbookDothandbookCategoriesIndexRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook.handbook/categories/index";
import { Route as AdminPanelApplicationDotapplicationCategoriesIndexRouteImport } from "./../modules/application/admin/pages/_panel/_application.application/categories/index";
import { Route as AdminPanelApplicationDotapplicationApplicationsIndexRouteImport } from "./../modules/application/admin/pages/_panel/_application.application/applications/index";
import { Route as AdminPanelSettingsDotsettingsRolesCreateRouteImport } from "./admin/pages/_panel/_settings.settings/roles/create";
import { Route as AdminPanelSettingsDotsettingsRolesIdRouteImport } from "./admin/pages/_panel/_settings.settings/roles/$id";
import { Route as AdminPanelSettingsDotsettingsEntityCreateRouteImport } from "./admin/pages/_panel/_settings.settings/entity/create";
import { Route as AdminPanelSettingsDotsettingsEntityIdRouteImport } from "./admin/pages/_panel/_settings.settings/entity/$id";
import { Route as AdminPanelReportDotreportReportsCreateRouteImport } from "./../modules/report/admin/pages/_panel/_report.report/reports/create";
import { Route as AdminPanelReportDotreportReportsIdRouteImport } from "./../modules/report/admin/pages/_panel/_report.report/reports/$id";
import { Route as AdminPanelRecognitionDotrecognitionTransactionsRewardsRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/transactions/rewards";
import { Route as AdminPanelRecognitionDotrecognitionPeriodReportsIdRouteImport } from "./../modules/recognition/admin/pages/_panel/_recognition.recognition/period-reports/$id";
import { Route as AdminPanelHandbookDothandbookEntriesCreateRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook.handbook/entries/create";
import { Route as AdminPanelHandbookDothandbookEntriesEntryRouteImport } from "./../modules/handbook/admin/pages/_panel/_handbook.handbook/entries/$entry";
import { Route as AdminPanelApplicationDotapplicationApplicationsCreateRouteImport } from "./../modules/application/admin/pages/_panel/_application.application/applications/create";
import { Route as AdminPanelApplicationDotapplicationApplicationsIdRouteImport } from "./../modules/application/admin/pages/_panel/_application.application/applications/$id";
import { Route as PanelPerformanceDotperformanceObjectivesEditIdRouteImport } from "./../modules/performance/user/pages/_panel/_performance.performance/objectives/edit/$id";
import { Route as PanelMessengerDotmessengerGroupsJoinTokenRouteImport } from "./../modules/messenger/user/pages/_panel/_messenger.messenger/groups/join/$token";
import { Route as PanelApplicationDotapplicationApplicationsIdRequestRouteImport } from "./../modules/application/user/pages/_panel/_application.application/applications/$id/request";
import { Route as AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/reviews.periods/index";
import { Route as AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/objectives.periods/index";
import { Route as AdminPanelChartDotchartTypeUnitsIndexRouteImport } from "./../modules/chart/admin/pages/_panel/_chart.chart/$type/units/index";
import { Route as AdminPanelChartDotchartTypePositionsIndexRouteImport } from "./../modules/chart/admin/pages/_panel/_chart.chart/$type/positions/index";
import { Route as AdminPanelReportDotreportReportsViewIdRouteImport } from "./../modules/report/admin/pages/_panel/_report.report/reports/view/$id";
import { Route as AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/reviews.periods/create";
import { Route as AdminPanelPerformanceDotperformanceReviewsDotformsCreateRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/reviews.forms/create";
import { Route as AdminPanelPerformanceDotperformanceReviewsDotformsIdRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/reviews.forms/$id";
import { Route as AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/objectives.periods/create";
import { Route as AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/checkins-meetings.forms/create";
import { Route as AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRouteImport } from "./../modules/performance/admin/pages/_panel/_performance.performance/checkins-meetings.forms/$id";

const AdminRouteImport = createFileRoute("/admin")();

const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const PanelRoute = PanelRouteImport.update({
  id: "/_panel",
  getParentRoute: () => rootRouteImport,
} as any);
const MeetRoute = MeetRouteImport.update({
  id: "/_meet",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminPanelRoute = AdminPanelRouteImport.update({
  id: "/_panel",
  getParentRoute: () => AdminRoute,
} as any);
const PanelSettingsRoute = PanelSettingsRouteImport.update({
  id: "/_settings",
  getParentRoute: () => PanelRoute,
} as any);
const PanelRecognitionRoute = PanelRecognitionRouteImport.update({
  id: "/_recognition",
  getParentRoute: () => PanelRoute,
} as any);
const PanelProfileRoute = PanelProfileRouteImport.update({
  id: "/_profile",
  getParentRoute: () => PanelRoute,
} as any);
const PanelPerformanceRoute = PanelPerformanceRouteImport.update({
  id: "/_performance",
  getParentRoute: () => PanelRoute,
} as any);
const PanelNewsRoute = PanelNewsRouteImport.update({
  id: "/_news",
  getParentRoute: () => PanelRoute,
} as any);
const PanelMessengerRoute = PanelMessengerRouteImport.update({
  id: "/_messenger",
  getParentRoute: () => PanelRoute,
} as any);
const PanelMeetRoute = PanelMeetRouteImport.update({
  id: "/_meet",
  getParentRoute: () => PanelRoute,
} as any);
const PanelHandbookRoute = PanelHandbookRouteImport.update({
  id: "/_handbook",
  getParentRoute: () => PanelRoute,
} as any);
const PanelCoreRoute = PanelCoreRouteImport.update({
  id: "/_core",
  getParentRoute: () => PanelRoute,
} as any);
const PanelChartRoute = PanelChartRouteImport.update({
  id: "/_chart",
  getParentRoute: () => PanelRoute,
} as any);
const PanelApplicationRoute = PanelApplicationRouteImport.update({
  id: "/_application",
  getParentRoute: () => PanelRoute,
} as any);
const PanelCoreIndexRoute = PanelCoreIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PanelCoreRoute,
} as any);
const AdminPanelSettingsRoute = AdminPanelSettingsRouteImport.update({
  id: "/_settings",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelReportRoute = AdminPanelReportRouteImport.update({
  id: "/_report",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelRecognitionRoute = AdminPanelRecognitionRouteImport.update({
  id: "/_recognition",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelProfileRoute = AdminPanelProfileRouteImport.update({
  id: "/_profile",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelPerformanceRoute = AdminPanelPerformanceRouteImport.update({
  id: "/_performance",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelNewsRoute = AdminPanelNewsRouteImport.update({
  id: "/_news",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelMoodRoute = AdminPanelMoodRouteImport.update({
  id: "/_mood",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelMessengerRoute = AdminPanelMessengerRouteImport.update({
  id: "/_messenger",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelHandbookRoute = AdminPanelHandbookRouteImport.update({
  id: "/_handbook",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelCoreRoute = AdminPanelCoreRouteImport.update({
  id: "/_core",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelChartRoute = AdminPanelChartRouteImport.update({
  id: "/_chart",
  getParentRoute: () => AdminPanelRoute,
} as any);
const AdminPanelApplicationRoute = AdminPanelApplicationRouteImport.update({
  id: "/_application",
  getParentRoute: () => AdminPanelRoute,
} as any);
const MeetDotmeetCodeRoute = MeetDotmeetCodeRouteImport.update({
  id: "/meet/$code",
  path: "/meet/$code",
  getParentRoute: () => MeetRoute,
} as any);
const AdminPanelCoreIndexRoute = AdminPanelCoreIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminPanelCoreRoute,
} as any);
const PanelSettingsDotsettingsIndexRoute =
  PanelSettingsDotsettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => PanelSettingsRoute,
  } as any);
const PanelRecognitionDotrecognitionIndexRoute =
  PanelRecognitionDotrecognitionIndexRouteImport.update({
    id: "/recognition/",
    path: "/recognition/",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelPerformanceDotperformanceIndexRoute =
  PanelPerformanceDotperformanceIndexRouteImport.update({
    id: "/performance/",
    path: "/performance/",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelNewsDotnewsIndexRoute = PanelNewsDotnewsIndexRouteImport.update({
  id: "/news/",
  path: "/news/",
  getParentRoute: () => PanelNewsRoute,
} as any);
const PanelMessengerDotmessengerIndexRoute =
  PanelMessengerDotmessengerIndexRouteImport.update({
    id: "/messenger/",
    path: "/messenger/",
    getParentRoute: () => PanelMessengerRoute,
  } as any);
const ApplicationDotrequestsDotuuidDotuuidRoute =
  ApplicationDotrequestsDotuuidDotuuidRouteImport.update({
    id: "/application/requests/uuid/$uuid",
    path: "/application/requests/uuid/$uuid",
    getParentRoute: () => rootRouteImport,
  } as any);
const PanelSettingsDotsettingsNotificationsRoute =
  PanelSettingsDotsettingsNotificationsRouteImport.update({
    id: "/settings/notifications",
    path: "/settings/notifications",
    getParentRoute: () => PanelSettingsRoute,
  } as any);
const PanelSettingsDotsettingsLocaleRoute =
  PanelSettingsDotsettingsLocaleRouteImport.update({
    id: "/settings/locale",
    path: "/settings/locale",
    getParentRoute: () => PanelSettingsRoute,
  } as any);
const PanelProfileDotprofileMeRoute =
  PanelProfileDotprofileMeRouteImport.update({
    id: "/profile/me",
    path: "/profile/me",
    getParentRoute: () => PanelProfileRoute,
  } as any);
const PanelProfileDotprofileIdRoute =
  PanelProfileDotprofileIdRouteImport.update({
    id: "/profile/$id",
    path: "/profile/$id",
    getParentRoute: () => PanelProfileRoute,
  } as any);
const PanelNewsDotnewsIdRoute = PanelNewsDotnewsIdRouteImport.update({
  id: "/news/$id",
  path: "/news/$id",
  getParentRoute: () => PanelNewsRoute,
} as any);
const PanelMessengerDotmessengerIdRoute =
  PanelMessengerDotmessengerIdRouteImport.update({
    id: "/messenger/$id",
    path: "/messenger/$id",
    getParentRoute: () => PanelMessengerRoute,
  } as any);
const AdminPanelSettingsDotsettingsIndexRoute =
  AdminPanelSettingsDotsettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelProfileDotprofileIndexRoute =
  AdminPanelProfileDotprofileIndexRouteImport.update({
    id: "/profile/",
    path: "/profile/",
    getParentRoute: () => AdminPanelProfileRoute,
  } as any);
const AdminPanelNewsDotnewsIndexRoute =
  AdminPanelNewsDotnewsIndexRouteImport.update({
    id: "/news/",
    path: "/news/",
    getParentRoute: () => AdminPanelNewsRoute,
  } as any);
const AdminPanelMoodDotmoodIndexRoute =
  AdminPanelMoodDotmoodIndexRouteImport.update({
    id: "/mood/",
    path: "/mood/",
    getParentRoute: () => AdminPanelMoodRoute,
  } as any);
const AdminPanelHandbookDothandbookIndexRoute =
  AdminPanelHandbookDothandbookIndexRouteImport.update({
    id: "/handbook/",
    path: "/handbook/",
    getParentRoute: () => AdminPanelHandbookRoute,
  } as any);
const AdminPanelChartDotchartIndexRoute =
  AdminPanelChartDotchartIndexRouteImport.update({
    id: "/chart/",
    path: "/chart/",
    getParentRoute: () => AdminPanelChartRoute,
  } as any);
const PanelRecognitionDotrecognitionTopIndexRoute =
  PanelRecognitionDotrecognitionTopIndexRouteImport.update({
    id: "/recognition/top/",
    path: "/recognition/top/",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelRecognitionDotrecognitionRewardsIndexRoute =
  PanelRecognitionDotrecognitionRewardsIndexRouteImport.update({
    id: "/recognition/rewards/",
    path: "/recognition/rewards/",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelPerformanceDotperformanceReviewsIndexRoute =
  PanelPerformanceDotperformanceReviewsIndexRouteImport.update({
    id: "/performance/reviews/",
    path: "/performance/reviews/",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelPerformanceDotperformanceObjectivesIndexRoute =
  PanelPerformanceDotperformanceObjectivesIndexRouteImport.update({
    id: "/performance/objectives/",
    path: "/performance/objectives/",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelPerformanceDotperformanceCheckinsIndexRoute =
  PanelPerformanceDotperformanceCheckinsIndexRouteImport.update({
    id: "/performance/checkins/",
    path: "/performance/checkins/",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelNewsDotnewsCategoriesIndexRoute =
  PanelNewsDotnewsCategoriesIndexRouteImport.update({
    id: "/news/categories/",
    path: "/news/categories/",
    getParentRoute: () => PanelNewsRoute,
  } as any);
const PanelMeetDotmeetSessionsIndexRoute =
  PanelMeetDotmeetSessionsIndexRouteImport.update({
    id: "/meet/sessions/",
    path: "/meet/sessions/",
    getParentRoute: () => PanelMeetRoute,
  } as any);
const PanelHandbookDothandbookEntriesIndexRoute =
  PanelHandbookDothandbookEntriesIndexRouteImport.update({
    id: "/handbook/entries/",
    path: "/handbook/entries/",
    getParentRoute: () => PanelHandbookRoute,
  } as any);
const PanelApplicationDotapplicationRequestsIndexRoute =
  PanelApplicationDotapplicationRequestsIndexRouteImport.update({
    id: "/application/requests/",
    path: "/application/requests/",
    getParentRoute: () => PanelApplicationRoute,
  } as any);
const PanelApplicationDotapplicationApplicationsIndexRoute =
  PanelApplicationDotapplicationApplicationsIndexRouteImport.update({
    id: "/application/applications/",
    path: "/application/applications/",
    getParentRoute: () => PanelApplicationRoute,
  } as any);
const AdminPanelSettingsDotsettingsUsersRoute =
  AdminPanelSettingsDotsettingsUsersRouteImport.update({
    id: "/settings/users",
    path: "/settings/users",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsRecognitionRoute =
  AdminPanelSettingsDotsettingsRecognitionRouteImport.update({
    id: "/settings/recognition",
    path: "/settings/recognition",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsProfileRoute =
  AdminPanelSettingsDotsettingsProfileRouteImport.update({
    id: "/settings/profile",
    path: "/settings/profile",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsPerformanceRoute =
  AdminPanelSettingsDotsettingsPerformanceRouteImport.update({
    id: "/settings/performance",
    path: "/settings/performance",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsNotificationsRoute =
  AdminPanelSettingsDotsettingsNotificationsRouteImport.update({
    id: "/settings/notifications",
    path: "/settings/notifications",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsNewsRoute =
  AdminPanelSettingsDotsettingsNewsRouteImport.update({
    id: "/settings/news",
    path: "/settings/news",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsMoodRoute =
  AdminPanelSettingsDotsettingsMoodRouteImport.update({
    id: "/settings/mood",
    path: "/settings/mood",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelProfileDotprofileRequestsRoute =
  AdminPanelProfileDotprofileRequestsRouteImport.update({
    id: "/profile/requests",
    path: "/profile/requests",
    getParentRoute: () => AdminPanelProfileRoute,
  } as any);
const AdminPanelNewsDotnewsCreateRoute =
  AdminPanelNewsDotnewsCreateRouteImport.update({
    id: "/news/create",
    path: "/news/create",
    getParentRoute: () => AdminPanelNewsRoute,
  } as any);
const AdminPanelNewsDotnewsIdRoute = AdminPanelNewsDotnewsIdRouteImport.update({
  id: "/news/$id",
  path: "/news/$id",
  getParentRoute: () => AdminPanelNewsRoute,
} as any);
const AdminPanelChartDotchartTypeRoute =
  AdminPanelChartDotchartTypeRouteImport.update({
    id: "/chart/$type",
    path: "/chart/$type",
    getParentRoute: () => AdminPanelChartRoute,
  } as any);
const PanelRecognitionDotrecognitionTransactionsTransfersRoute =
  PanelRecognitionDotrecognitionTransactionsTransfersRouteImport.update({
    id: "/recognition/transactions/transfers",
    path: "/recognition/transactions/transfers",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelRecognitionDotrecognitionTransactionsRewardsRoute =
  PanelRecognitionDotrecognitionTransactionsRewardsRouteImport.update({
    id: "/recognition/transactions/rewards",
    path: "/recognition/transactions/rewards",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelRecognitionDotrecognitionTopIdRoute =
  PanelRecognitionDotrecognitionTopIdRouteImport.update({
    id: "/recognition/top/$id",
    path: "/recognition/top/$id",
    getParentRoute: () => PanelRecognitionRoute,
  } as any);
const PanelPerformanceDotperformanceObjectivesCreateRoute =
  PanelPerformanceDotperformanceObjectivesCreateRouteImport.update({
    id: "/performance/objectives/create",
    path: "/performance/objectives/create",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelPerformanceDotperformanceObjectivesIdRoute =
  PanelPerformanceDotperformanceObjectivesIdRouteImport.update({
    id: "/performance/objectives/$id",
    path: "/performance/objectives/$id",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelPerformanceDotperformanceCheckinsCreateRoute =
  PanelPerformanceDotperformanceCheckinsCreateRouteImport.update({
    id: "/performance/checkins/create",
    path: "/performance/checkins/create",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelPerformanceDotperformanceCheckinsIdRoute =
  PanelPerformanceDotperformanceCheckinsIdRouteImport.update({
    id: "/performance/checkins/$id",
    path: "/performance/checkins/$id",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelHandbookDothandbookEntriesIdRoute =
  PanelHandbookDothandbookEntriesIdRouteImport.update({
    id: "/handbook/entries/$id",
    path: "/handbook/entries/$id",
    getParentRoute: () => PanelHandbookRoute,
  } as any);
const PanelChartDotchartChartsTypeRoute =
  PanelChartDotchartChartsTypeRouteImport.update({
    id: "/chart/charts/$type",
    path: "/chart/charts/$type",
    getParentRoute: () => PanelChartRoute,
  } as any);
const PanelApplicationDotapplicationRequestsIdRoute =
  PanelApplicationDotapplicationRequestsIdRouteImport.update({
    id: "/application/requests/$id",
    path: "/application/requests/$id",
    getParentRoute: () => PanelApplicationRoute,
  } as any);
const AdminPanelSettingsDotsettingsRolesIndexRoute =
  AdminPanelSettingsDotsettingsRolesIndexRouteImport.update({
    id: "/settings/roles/",
    path: "/settings/roles/",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsEntityIndexRoute =
  AdminPanelSettingsDotsettingsEntityIndexRouteImport.update({
    id: "/settings/entity/",
    path: "/settings/entity/",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelReportDotreportReportsIndexRoute =
  AdminPanelReportDotreportReportsIndexRouteImport.update({
    id: "/report/reports/",
    path: "/report/reports/",
    getParentRoute: () => AdminPanelReportRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionValuesIndexRoute =
  AdminPanelRecognitionDotrecognitionValuesIndexRouteImport.update({
    id: "/recognition/values/",
    path: "/recognition/values/",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionTransactionsIndexRoute =
  AdminPanelRecognitionDotrecognitionTransactionsIndexRouteImport.update({
    id: "/recognition/transactions/",
    path: "/recognition/transactions/",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionRewardsIndexRoute =
  AdminPanelRecognitionDotrecognitionRewardsIndexRouteImport.update({
    id: "/recognition/rewards/",
    path: "/recognition/rewards/",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionPeriodsIndexRoute =
  AdminPanelRecognitionDotrecognitionPeriodsIndexRouteImport.update({
    id: "/recognition/periods/",
    path: "/recognition/periods/",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute =
  AdminPanelRecognitionDotrecognitionPeriodReportsIndexRouteImport.update({
    id: "/recognition/period-reports/",
    path: "/recognition/period-reports/",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelPerformanceDotperformanceTagsIndexRoute =
  AdminPanelPerformanceDotperformanceTagsIndexRouteImport.update({
    id: "/performance/tags/",
    path: "/performance/tags/",
    getParentRoute: () => AdminPanelPerformanceRoute,
  } as any);
const AdminPanelNewsDotnewsCommentsIndexRoute =
  AdminPanelNewsDotnewsCommentsIndexRouteImport.update({
    id: "/news/comments/",
    path: "/news/comments/",
    getParentRoute: () => AdminPanelNewsRoute,
  } as any);
const AdminPanelNewsDotnewsCategoriesIndexRoute =
  AdminPanelNewsDotnewsCategoriesIndexRouteImport.update({
    id: "/news/categories/",
    path: "/news/categories/",
    getParentRoute: () => AdminPanelNewsRoute,
  } as any);
const AdminPanelMessengerDotmessengerGroupsIndexRoute =
  AdminPanelMessengerDotmessengerGroupsIndexRouteImport.update({
    id: "/messenger/groups/",
    path: "/messenger/groups/",
    getParentRoute: () => AdminPanelMessengerRoute,
  } as any);
const AdminPanelHandbookDothandbookEntriesIndexRoute =
  AdminPanelHandbookDothandbookEntriesIndexRouteImport.update({
    id: "/handbook/entries/",
    path: "/handbook/entries/",
    getParentRoute: () => AdminPanelHandbookRoute,
  } as any);
const AdminPanelHandbookDothandbookCategoriesIndexRoute =
  AdminPanelHandbookDothandbookCategoriesIndexRouteImport.update({
    id: "/handbook/categories/",
    path: "/handbook/categories/",
    getParentRoute: () => AdminPanelHandbookRoute,
  } as any);
const AdminPanelApplicationDotapplicationCategoriesIndexRoute =
  AdminPanelApplicationDotapplicationCategoriesIndexRouteImport.update({
    id: "/application/categories/",
    path: "/application/categories/",
    getParentRoute: () => AdminPanelApplicationRoute,
  } as any);
const AdminPanelApplicationDotapplicationApplicationsIndexRoute =
  AdminPanelApplicationDotapplicationApplicationsIndexRouteImport.update({
    id: "/application/applications/",
    path: "/application/applications/",
    getParentRoute: () => AdminPanelApplicationRoute,
  } as any);
const AdminPanelSettingsDotsettingsRolesCreateRoute =
  AdminPanelSettingsDotsettingsRolesCreateRouteImport.update({
    id: "/settings/roles/create",
    path: "/settings/roles/create",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsRolesIdRoute =
  AdminPanelSettingsDotsettingsRolesIdRouteImport.update({
    id: "/settings/roles/$id",
    path: "/settings/roles/$id",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsEntityCreateRoute =
  AdminPanelSettingsDotsettingsEntityCreateRouteImport.update({
    id: "/settings/entity/create",
    path: "/settings/entity/create",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelSettingsDotsettingsEntityIdRoute =
  AdminPanelSettingsDotsettingsEntityIdRouteImport.update({
    id: "/settings/entity/$id",
    path: "/settings/entity/$id",
    getParentRoute: () => AdminPanelSettingsRoute,
  } as any);
const AdminPanelReportDotreportReportsCreateRoute =
  AdminPanelReportDotreportReportsCreateRouteImport.update({
    id: "/report/reports/create",
    path: "/report/reports/create",
    getParentRoute: () => AdminPanelReportRoute,
  } as any);
const AdminPanelReportDotreportReportsIdRoute =
  AdminPanelReportDotreportReportsIdRouteImport.update({
    id: "/report/reports/$id",
    path: "/report/reports/$id",
    getParentRoute: () => AdminPanelReportRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute =
  AdminPanelRecognitionDotrecognitionTransactionsRewardsRouteImport.update({
    id: "/recognition/transactions/rewards",
    path: "/recognition/transactions/rewards",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute =
  AdminPanelRecognitionDotrecognitionPeriodReportsIdRouteImport.update({
    id: "/recognition/period-reports/$id",
    path: "/recognition/period-reports/$id",
    getParentRoute: () => AdminPanelRecognitionRoute,
  } as any);
const AdminPanelHandbookDothandbookEntriesCreateRoute =
  AdminPanelHandbookDothandbookEntriesCreateRouteImport.update({
    id: "/handbook/entries/create",
    path: "/handbook/entries/create",
    getParentRoute: () => AdminPanelHandbookRoute,
  } as any);
const AdminPanelHandbookDothandbookEntriesEntryRoute =
  AdminPanelHandbookDothandbookEntriesEntryRouteImport.update({
    id: "/handbook/entries/$entry",
    path: "/handbook/entries/$entry",
    getParentRoute: () => AdminPanelHandbookRoute,
  } as any);
const AdminPanelApplicationDotapplicationApplicationsCreateRoute =
  AdminPanelApplicationDotapplicationApplicationsCreateRouteImport.update({
    id: "/application/applications/create",
    path: "/application/applications/create",
    getParentRoute: () => AdminPanelApplicationRoute,
  } as any);
const AdminPanelApplicationDotapplicationApplicationsIdRoute =
  AdminPanelApplicationDotapplicationApplicationsIdRouteImport.update({
    id: "/application/applications/$id",
    path: "/application/applications/$id",
    getParentRoute: () => AdminPanelApplicationRoute,
  } as any);
const PanelPerformanceDotperformanceObjectivesEditIdRoute =
  PanelPerformanceDotperformanceObjectivesEditIdRouteImport.update({
    id: "/performance/objectives/edit/$id",
    path: "/performance/objectives/edit/$id",
    getParentRoute: () => PanelPerformanceRoute,
  } as any);
const PanelMessengerDotmessengerGroupsJoinTokenRoute =
  PanelMessengerDotmessengerGroupsJoinTokenRouteImport.update({
    id: "/messenger/groups/join/$token",
    path: "/messenger/groups/join/$token",
    getParentRoute: () => PanelMessengerRoute,
  } as any);
const PanelApplicationDotapplicationApplicationsIdRequestRoute =
  PanelApplicationDotapplicationApplicationsIdRequestRouteImport.update({
    id: "/application/applications/$id/request",
    path: "/application/applications/$id/request",
    getParentRoute: () => PanelApplicationRoute,
  } as any);
const AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute =
  AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRouteImport.update({
    id: "/performance/reviews/periods/",
    path: "/performance/reviews/periods/",
    getParentRoute: () => AdminPanelPerformanceRoute,
  } as any);
const AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute =
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRouteImport.update(
    {
      id: "/performance/objectives/periods/",
      path: "/performance/objectives/periods/",
      getParentRoute: () => AdminPanelPerformanceRoute,
    } as any,
  );
const AdminPanelChartDotchartTypeUnitsIndexRoute =
  AdminPanelChartDotchartTypeUnitsIndexRouteImport.update({
    id: "/units/",
    path: "/units/",
    getParentRoute: () => AdminPanelChartDotchartTypeRoute,
  } as any);
const AdminPanelChartDotchartTypePositionsIndexRoute =
  AdminPanelChartDotchartTypePositionsIndexRouteImport.update({
    id: "/positions/",
    path: "/positions/",
    getParentRoute: () => AdminPanelChartDotchartTypeRoute,
  } as any);
const AdminPanelReportDotreportReportsViewIdRoute =
  AdminPanelReportDotreportReportsViewIdRouteImport.update({
    id: "/report/reports/view/$id",
    path: "/report/reports/view/$id",
    getParentRoute: () => AdminPanelReportRoute,
  } as any);
const AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute =
  AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRouteImport.update({
    id: "/performance/reviews/periods/create",
    path: "/performance/reviews/periods/create",
    getParentRoute: () => AdminPanelPerformanceRoute,
  } as any);
const AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute =
  AdminPanelPerformanceDotperformanceReviewsDotformsCreateRouteImport.update({
    id: "/performance/reviews/forms/create",
    path: "/performance/reviews/forms/create",
    getParentRoute: () => AdminPanelPerformanceRoute,
  } as any);
const AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute =
  AdminPanelPerformanceDotperformanceReviewsDotformsIdRouteImport.update({
    id: "/performance/reviews/forms/$id",
    path: "/performance/reviews/forms/$id",
    getParentRoute: () => AdminPanelPerformanceRoute,
  } as any);
const AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute =
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRouteImport.update(
    {
      id: "/performance/objectives/periods/create",
      path: "/performance/objectives/periods/create",
      getParentRoute: () => AdminPanelPerformanceRoute,
    } as any,
  );
const AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute =
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRouteImport.update(
    {
      id: "/performance/checkins-meetings/forms/create",
      path: "/performance/checkins-meetings/forms/create",
      getParentRoute: () => AdminPanelPerformanceRoute,
    } as any,
  );
const AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute =
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRouteImport.update(
    {
      id: "/performance/checkins-meetings/forms/$id",
      path: "/performance/checkins-meetings/forms/$id",
      getParentRoute: () => AdminPanelPerformanceRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/login": typeof LoginRoute;
  "/admin": typeof AdminPanelSettingsRouteWithChildren;
  "/meet/$code": typeof MeetDotmeetCodeRoute;
  "/": typeof PanelCoreIndexRoute;
  "/messenger/$id": typeof PanelMessengerDotmessengerIdRoute;
  "/news/$id": typeof PanelNewsDotnewsIdRoute;
  "/profile/$id": typeof PanelProfileDotprofileIdRoute;
  "/profile/me": typeof PanelProfileDotprofileMeRoute;
  "/settings/locale": typeof PanelSettingsDotsettingsLocaleRoute;
  "/settings/notifications": typeof PanelSettingsDotsettingsNotificationsRoute;
  "/application/requests/uuid/$uuid": typeof ApplicationDotrequestsDotuuidDotuuidRoute;
  "/messenger": typeof PanelMessengerDotmessengerIndexRoute;
  "/news": typeof PanelNewsDotnewsIndexRoute;
  "/performance": typeof PanelPerformanceDotperformanceIndexRoute;
  "/recognition": typeof PanelRecognitionDotrecognitionIndexRoute;
  "/settings": typeof PanelSettingsDotsettingsIndexRoute;
  "/admin/": typeof AdminPanelCoreIndexRoute;
  "/application/requests/$id": typeof PanelApplicationDotapplicationRequestsIdRoute;
  "/chart/charts/$type": typeof PanelChartDotchartChartsTypeRoute;
  "/handbook/entries/$id": typeof PanelHandbookDothandbookEntriesIdRoute;
  "/performance/checkins/$id": typeof PanelPerformanceDotperformanceCheckinsIdRoute;
  "/performance/checkins/create": typeof PanelPerformanceDotperformanceCheckinsCreateRoute;
  "/performance/objectives/$id": typeof PanelPerformanceDotperformanceObjectivesIdRoute;
  "/performance/objectives/create": typeof PanelPerformanceDotperformanceObjectivesCreateRoute;
  "/recognition/top/$id": typeof PanelRecognitionDotrecognitionTopIdRoute;
  "/recognition/transactions/rewards": typeof PanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/recognition/transactions/transfers": typeof PanelRecognitionDotrecognitionTransactionsTransfersRoute;
  "/admin/chart/$type": typeof AdminPanelChartDotchartTypeRouteWithChildren;
  "/admin/news/$id": typeof AdminPanelNewsDotnewsIdRoute;
  "/admin/news/create": typeof AdminPanelNewsDotnewsCreateRoute;
  "/admin/profile/requests": typeof AdminPanelProfileDotprofileRequestsRoute;
  "/admin/settings/mood": typeof AdminPanelSettingsDotsettingsMoodRoute;
  "/admin/settings/news": typeof AdminPanelSettingsDotsettingsNewsRoute;
  "/admin/settings/notifications": typeof AdminPanelSettingsDotsettingsNotificationsRoute;
  "/admin/settings/performance": typeof AdminPanelSettingsDotsettingsPerformanceRoute;
  "/admin/settings/profile": typeof AdminPanelSettingsDotsettingsProfileRoute;
  "/admin/settings/recognition": typeof AdminPanelSettingsDotsettingsRecognitionRoute;
  "/admin/settings/users": typeof AdminPanelSettingsDotsettingsUsersRoute;
  "/application/applications": typeof PanelApplicationDotapplicationApplicationsIndexRoute;
  "/application/requests": typeof PanelApplicationDotapplicationRequestsIndexRoute;
  "/handbook/entries": typeof PanelHandbookDothandbookEntriesIndexRoute;
  "/meet/sessions": typeof PanelMeetDotmeetSessionsIndexRoute;
  "/news/categories": typeof PanelNewsDotnewsCategoriesIndexRoute;
  "/performance/checkins": typeof PanelPerformanceDotperformanceCheckinsIndexRoute;
  "/performance/objectives": typeof PanelPerformanceDotperformanceObjectivesIndexRoute;
  "/performance/reviews": typeof PanelPerformanceDotperformanceReviewsIndexRoute;
  "/recognition/rewards": typeof PanelRecognitionDotrecognitionRewardsIndexRoute;
  "/recognition/top": typeof PanelRecognitionDotrecognitionTopIndexRoute;
  "/admin/chart": typeof AdminPanelChartDotchartIndexRoute;
  "/admin/handbook": typeof AdminPanelHandbookDothandbookIndexRoute;
  "/admin/mood": typeof AdminPanelMoodDotmoodIndexRoute;
  "/admin/news": typeof AdminPanelNewsDotnewsIndexRoute;
  "/admin/profile": typeof AdminPanelProfileDotprofileIndexRoute;
  "/admin/settings": typeof AdminPanelSettingsDotsettingsIndexRoute;
  "/application/applications/$id/request": typeof PanelApplicationDotapplicationApplicationsIdRequestRoute;
  "/messenger/groups/join/$token": typeof PanelMessengerDotmessengerGroupsJoinTokenRoute;
  "/performance/objectives/edit/$id": typeof PanelPerformanceDotperformanceObjectivesEditIdRoute;
  "/admin/application/applications/$id": typeof AdminPanelApplicationDotapplicationApplicationsIdRoute;
  "/admin/application/applications/create": typeof AdminPanelApplicationDotapplicationApplicationsCreateRoute;
  "/admin/handbook/entries/$entry": typeof AdminPanelHandbookDothandbookEntriesEntryRoute;
  "/admin/handbook/entries/create": typeof AdminPanelHandbookDothandbookEntriesCreateRoute;
  "/admin/recognition/period-reports/$id": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute;
  "/admin/recognition/transactions/rewards": typeof AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/admin/report/reports/$id": typeof AdminPanelReportDotreportReportsIdRoute;
  "/admin/report/reports/create": typeof AdminPanelReportDotreportReportsCreateRoute;
  "/admin/settings/entity/$id": typeof AdminPanelSettingsDotsettingsEntityIdRoute;
  "/admin/settings/entity/create": typeof AdminPanelSettingsDotsettingsEntityCreateRoute;
  "/admin/settings/roles/$id": typeof AdminPanelSettingsDotsettingsRolesIdRoute;
  "/admin/settings/roles/create": typeof AdminPanelSettingsDotsettingsRolesCreateRoute;
  "/admin/application/applications": typeof AdminPanelApplicationDotapplicationApplicationsIndexRoute;
  "/admin/application/categories": typeof AdminPanelApplicationDotapplicationCategoriesIndexRoute;
  "/admin/handbook/categories": typeof AdminPanelHandbookDothandbookCategoriesIndexRoute;
  "/admin/handbook/entries": typeof AdminPanelHandbookDothandbookEntriesIndexRoute;
  "/admin/messenger/groups": typeof AdminPanelMessengerDotmessengerGroupsIndexRoute;
  "/admin/news/categories": typeof AdminPanelNewsDotnewsCategoriesIndexRoute;
  "/admin/news/comments": typeof AdminPanelNewsDotnewsCommentsIndexRoute;
  "/admin/performance/tags": typeof AdminPanelPerformanceDotperformanceTagsIndexRoute;
  "/admin/recognition/period-reports": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute;
  "/admin/recognition/periods": typeof AdminPanelRecognitionDotrecognitionPeriodsIndexRoute;
  "/admin/recognition/rewards": typeof AdminPanelRecognitionDotrecognitionRewardsIndexRoute;
  "/admin/recognition/transactions": typeof AdminPanelRecognitionDotrecognitionTransactionsIndexRoute;
  "/admin/recognition/values": typeof AdminPanelRecognitionDotrecognitionValuesIndexRoute;
  "/admin/report/reports": typeof AdminPanelReportDotreportReportsIndexRoute;
  "/admin/settings/entity": typeof AdminPanelSettingsDotsettingsEntityIndexRoute;
  "/admin/settings/roles": typeof AdminPanelSettingsDotsettingsRolesIndexRoute;
  "/admin/performance/checkins-meetings/forms/$id": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute;
  "/admin/performance/checkins-meetings/forms/create": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute;
  "/admin/performance/objectives/periods/create": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute;
  "/admin/performance/reviews/forms/$id": typeof AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute;
  "/admin/performance/reviews/forms/create": typeof AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute;
  "/admin/performance/reviews/periods/create": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute;
  "/admin/report/reports/view/$id": typeof AdminPanelReportDotreportReportsViewIdRoute;
  "/admin/chart/$type/positions": typeof AdminPanelChartDotchartTypePositionsIndexRoute;
  "/admin/chart/$type/units": typeof AdminPanelChartDotchartTypeUnitsIndexRoute;
  "/admin/performance/objectives/periods": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute;
  "/admin/performance/reviews/periods": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute;
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute;
  "/admin": typeof AdminPanelCoreIndexRoute;
  "/meet/$code": typeof MeetDotmeetCodeRoute;
  "/": typeof PanelCoreIndexRoute;
  "/messenger/$id": typeof PanelMessengerDotmessengerIdRoute;
  "/news/$id": typeof PanelNewsDotnewsIdRoute;
  "/profile/$id": typeof PanelProfileDotprofileIdRoute;
  "/profile/me": typeof PanelProfileDotprofileMeRoute;
  "/settings/locale": typeof PanelSettingsDotsettingsLocaleRoute;
  "/settings/notifications": typeof PanelSettingsDotsettingsNotificationsRoute;
  "/application/requests/uuid/$uuid": typeof ApplicationDotrequestsDotuuidDotuuidRoute;
  "/messenger": typeof PanelMessengerDotmessengerIndexRoute;
  "/news": typeof PanelNewsDotnewsIndexRoute;
  "/performance": typeof PanelPerformanceDotperformanceIndexRoute;
  "/recognition": typeof PanelRecognitionDotrecognitionIndexRoute;
  "/settings": typeof PanelSettingsDotsettingsIndexRoute;
  "/application/requests/$id": typeof PanelApplicationDotapplicationRequestsIdRoute;
  "/chart/charts/$type": typeof PanelChartDotchartChartsTypeRoute;
  "/handbook/entries/$id": typeof PanelHandbookDothandbookEntriesIdRoute;
  "/performance/checkins/$id": typeof PanelPerformanceDotperformanceCheckinsIdRoute;
  "/performance/checkins/create": typeof PanelPerformanceDotperformanceCheckinsCreateRoute;
  "/performance/objectives/$id": typeof PanelPerformanceDotperformanceObjectivesIdRoute;
  "/performance/objectives/create": typeof PanelPerformanceDotperformanceObjectivesCreateRoute;
  "/recognition/top/$id": typeof PanelRecognitionDotrecognitionTopIdRoute;
  "/recognition/transactions/rewards": typeof PanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/recognition/transactions/transfers": typeof PanelRecognitionDotrecognitionTransactionsTransfersRoute;
  "/admin/chart/$type": typeof AdminPanelChartDotchartTypeRouteWithChildren;
  "/admin/news/$id": typeof AdminPanelNewsDotnewsIdRoute;
  "/admin/news/create": typeof AdminPanelNewsDotnewsCreateRoute;
  "/admin/profile/requests": typeof AdminPanelProfileDotprofileRequestsRoute;
  "/admin/settings/mood": typeof AdminPanelSettingsDotsettingsMoodRoute;
  "/admin/settings/news": typeof AdminPanelSettingsDotsettingsNewsRoute;
  "/admin/settings/notifications": typeof AdminPanelSettingsDotsettingsNotificationsRoute;
  "/admin/settings/performance": typeof AdminPanelSettingsDotsettingsPerformanceRoute;
  "/admin/settings/profile": typeof AdminPanelSettingsDotsettingsProfileRoute;
  "/admin/settings/recognition": typeof AdminPanelSettingsDotsettingsRecognitionRoute;
  "/admin/settings/users": typeof AdminPanelSettingsDotsettingsUsersRoute;
  "/application/applications": typeof PanelApplicationDotapplicationApplicationsIndexRoute;
  "/application/requests": typeof PanelApplicationDotapplicationRequestsIndexRoute;
  "/handbook/entries": typeof PanelHandbookDothandbookEntriesIndexRoute;
  "/meet/sessions": typeof PanelMeetDotmeetSessionsIndexRoute;
  "/news/categories": typeof PanelNewsDotnewsCategoriesIndexRoute;
  "/performance/checkins": typeof PanelPerformanceDotperformanceCheckinsIndexRoute;
  "/performance/objectives": typeof PanelPerformanceDotperformanceObjectivesIndexRoute;
  "/performance/reviews": typeof PanelPerformanceDotperformanceReviewsIndexRoute;
  "/recognition/rewards": typeof PanelRecognitionDotrecognitionRewardsIndexRoute;
  "/recognition/top": typeof PanelRecognitionDotrecognitionTopIndexRoute;
  "/admin/chart": typeof AdminPanelChartDotchartIndexRoute;
  "/admin/handbook": typeof AdminPanelHandbookDothandbookIndexRoute;
  "/admin/mood": typeof AdminPanelMoodDotmoodIndexRoute;
  "/admin/news": typeof AdminPanelNewsDotnewsIndexRoute;
  "/admin/profile": typeof AdminPanelProfileDotprofileIndexRoute;
  "/admin/settings": typeof AdminPanelSettingsDotsettingsIndexRoute;
  "/application/applications/$id/request": typeof PanelApplicationDotapplicationApplicationsIdRequestRoute;
  "/messenger/groups/join/$token": typeof PanelMessengerDotmessengerGroupsJoinTokenRoute;
  "/performance/objectives/edit/$id": typeof PanelPerformanceDotperformanceObjectivesEditIdRoute;
  "/admin/application/applications/$id": typeof AdminPanelApplicationDotapplicationApplicationsIdRoute;
  "/admin/application/applications/create": typeof AdminPanelApplicationDotapplicationApplicationsCreateRoute;
  "/admin/handbook/entries/$entry": typeof AdminPanelHandbookDothandbookEntriesEntryRoute;
  "/admin/handbook/entries/create": typeof AdminPanelHandbookDothandbookEntriesCreateRoute;
  "/admin/recognition/period-reports/$id": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute;
  "/admin/recognition/transactions/rewards": typeof AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/admin/report/reports/$id": typeof AdminPanelReportDotreportReportsIdRoute;
  "/admin/report/reports/create": typeof AdminPanelReportDotreportReportsCreateRoute;
  "/admin/settings/entity/$id": typeof AdminPanelSettingsDotsettingsEntityIdRoute;
  "/admin/settings/entity/create": typeof AdminPanelSettingsDotsettingsEntityCreateRoute;
  "/admin/settings/roles/$id": typeof AdminPanelSettingsDotsettingsRolesIdRoute;
  "/admin/settings/roles/create": typeof AdminPanelSettingsDotsettingsRolesCreateRoute;
  "/admin/application/applications": typeof AdminPanelApplicationDotapplicationApplicationsIndexRoute;
  "/admin/application/categories": typeof AdminPanelApplicationDotapplicationCategoriesIndexRoute;
  "/admin/handbook/categories": typeof AdminPanelHandbookDothandbookCategoriesIndexRoute;
  "/admin/handbook/entries": typeof AdminPanelHandbookDothandbookEntriesIndexRoute;
  "/admin/messenger/groups": typeof AdminPanelMessengerDotmessengerGroupsIndexRoute;
  "/admin/news/categories": typeof AdminPanelNewsDotnewsCategoriesIndexRoute;
  "/admin/news/comments": typeof AdminPanelNewsDotnewsCommentsIndexRoute;
  "/admin/performance/tags": typeof AdminPanelPerformanceDotperformanceTagsIndexRoute;
  "/admin/recognition/period-reports": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute;
  "/admin/recognition/periods": typeof AdminPanelRecognitionDotrecognitionPeriodsIndexRoute;
  "/admin/recognition/rewards": typeof AdminPanelRecognitionDotrecognitionRewardsIndexRoute;
  "/admin/recognition/transactions": typeof AdminPanelRecognitionDotrecognitionTransactionsIndexRoute;
  "/admin/recognition/values": typeof AdminPanelRecognitionDotrecognitionValuesIndexRoute;
  "/admin/report/reports": typeof AdminPanelReportDotreportReportsIndexRoute;
  "/admin/settings/entity": typeof AdminPanelSettingsDotsettingsEntityIndexRoute;
  "/admin/settings/roles": typeof AdminPanelSettingsDotsettingsRolesIndexRoute;
  "/admin/performance/checkins-meetings/forms/$id": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute;
  "/admin/performance/checkins-meetings/forms/create": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute;
  "/admin/performance/objectives/periods/create": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute;
  "/admin/performance/reviews/forms/$id": typeof AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute;
  "/admin/performance/reviews/forms/create": typeof AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute;
  "/admin/performance/reviews/periods/create": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute;
  "/admin/report/reports/view/$id": typeof AdminPanelReportDotreportReportsViewIdRoute;
  "/admin/chart/$type/positions": typeof AdminPanelChartDotchartTypePositionsIndexRoute;
  "/admin/chart/$type/units": typeof AdminPanelChartDotchartTypeUnitsIndexRoute;
  "/admin/performance/objectives/periods": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute;
  "/admin/performance/reviews/periods": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_meet": typeof MeetRouteWithChildren;
  "/_panel": typeof PanelRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_panel/_application": typeof PanelApplicationRouteWithChildren;
  "/_panel/_chart": typeof PanelChartRouteWithChildren;
  "/_panel/_core": typeof PanelCoreRouteWithChildren;
  "/_panel/_handbook": typeof PanelHandbookRouteWithChildren;
  "/_panel/_meet": typeof PanelMeetRouteWithChildren;
  "/_panel/_messenger": typeof PanelMessengerRouteWithChildren;
  "/_panel/_news": typeof PanelNewsRouteWithChildren;
  "/_panel/_performance": typeof PanelPerformanceRouteWithChildren;
  "/_panel/_profile": typeof PanelProfileRouteWithChildren;
  "/_panel/_recognition": typeof PanelRecognitionRouteWithChildren;
  "/_panel/_settings": typeof PanelSettingsRouteWithChildren;
  "/admin": typeof AdminRouteWithChildren;
  "/admin/_panel": typeof AdminPanelRouteWithChildren;
  "/_meet/meet/$code": typeof MeetDotmeetCodeRoute;
  "/admin/_panel/_application": typeof AdminPanelApplicationRouteWithChildren;
  "/admin/_panel/_chart": typeof AdminPanelChartRouteWithChildren;
  "/admin/_panel/_core": typeof AdminPanelCoreRouteWithChildren;
  "/admin/_panel/_handbook": typeof AdminPanelHandbookRouteWithChildren;
  "/admin/_panel/_messenger": typeof AdminPanelMessengerRouteWithChildren;
  "/admin/_panel/_mood": typeof AdminPanelMoodRouteWithChildren;
  "/admin/_panel/_news": typeof AdminPanelNewsRouteWithChildren;
  "/admin/_panel/_performance": typeof AdminPanelPerformanceRouteWithChildren;
  "/admin/_panel/_profile": typeof AdminPanelProfileRouteWithChildren;
  "/admin/_panel/_recognition": typeof AdminPanelRecognitionRouteWithChildren;
  "/admin/_panel/_report": typeof AdminPanelReportRouteWithChildren;
  "/admin/_panel/_settings": typeof AdminPanelSettingsRouteWithChildren;
  "/_panel/_core/": typeof PanelCoreIndexRoute;
  "/_panel/_messenger/messenger/$id": typeof PanelMessengerDotmessengerIdRoute;
  "/_panel/_news/news/$id": typeof PanelNewsDotnewsIdRoute;
  "/_panel/_profile/profile/$id": typeof PanelProfileDotprofileIdRoute;
  "/_panel/_profile/profile/me": typeof PanelProfileDotprofileMeRoute;
  "/_panel/_settings/settings/locale": typeof PanelSettingsDotsettingsLocaleRoute;
  "/_panel/_settings/settings/notifications": typeof PanelSettingsDotsettingsNotificationsRoute;
  "/application/requests/uuid/$uuid": typeof ApplicationDotrequestsDotuuidDotuuidRoute;
  "/_panel/_messenger/messenger/": typeof PanelMessengerDotmessengerIndexRoute;
  "/_panel/_news/news/": typeof PanelNewsDotnewsIndexRoute;
  "/_panel/_performance/performance/": typeof PanelPerformanceDotperformanceIndexRoute;
  "/_panel/_recognition/recognition/": typeof PanelRecognitionDotrecognitionIndexRoute;
  "/_panel/_settings/settings/": typeof PanelSettingsDotsettingsIndexRoute;
  "/admin/_panel/_core/": typeof AdminPanelCoreIndexRoute;
  "/_panel/_application/application/requests/$id": typeof PanelApplicationDotapplicationRequestsIdRoute;
  "/_panel/_chart/chart/charts/$type": typeof PanelChartDotchartChartsTypeRoute;
  "/_panel/_handbook/handbook/entries/$id": typeof PanelHandbookDothandbookEntriesIdRoute;
  "/_panel/_performance/performance/checkins/$id": typeof PanelPerformanceDotperformanceCheckinsIdRoute;
  "/_panel/_performance/performance/checkins/create": typeof PanelPerformanceDotperformanceCheckinsCreateRoute;
  "/_panel/_performance/performance/objectives/$id": typeof PanelPerformanceDotperformanceObjectivesIdRoute;
  "/_panel/_performance/performance/objectives/create": typeof PanelPerformanceDotperformanceObjectivesCreateRoute;
  "/_panel/_recognition/recognition/top/$id": typeof PanelRecognitionDotrecognitionTopIdRoute;
  "/_panel/_recognition/recognition/transactions/rewards": typeof PanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/_panel/_recognition/recognition/transactions/transfers": typeof PanelRecognitionDotrecognitionTransactionsTransfersRoute;
  "/admin/_panel/_chart/chart/$type": typeof AdminPanelChartDotchartTypeRouteWithChildren;
  "/admin/_panel/_news/news/$id": typeof AdminPanelNewsDotnewsIdRoute;
  "/admin/_panel/_news/news/create": typeof AdminPanelNewsDotnewsCreateRoute;
  "/admin/_panel/_profile/profile/requests": typeof AdminPanelProfileDotprofileRequestsRoute;
  "/admin/_panel/_settings/settings/mood": typeof AdminPanelSettingsDotsettingsMoodRoute;
  "/admin/_panel/_settings/settings/news": typeof AdminPanelSettingsDotsettingsNewsRoute;
  "/admin/_panel/_settings/settings/notifications": typeof AdminPanelSettingsDotsettingsNotificationsRoute;
  "/admin/_panel/_settings/settings/performance": typeof AdminPanelSettingsDotsettingsPerformanceRoute;
  "/admin/_panel/_settings/settings/profile": typeof AdminPanelSettingsDotsettingsProfileRoute;
  "/admin/_panel/_settings/settings/recognition": typeof AdminPanelSettingsDotsettingsRecognitionRoute;
  "/admin/_panel/_settings/settings/users": typeof AdminPanelSettingsDotsettingsUsersRoute;
  "/_panel/_application/application/applications/": typeof PanelApplicationDotapplicationApplicationsIndexRoute;
  "/_panel/_application/application/requests/": typeof PanelApplicationDotapplicationRequestsIndexRoute;
  "/_panel/_handbook/handbook/entries/": typeof PanelHandbookDothandbookEntriesIndexRoute;
  "/_panel/_meet/meet/sessions/": typeof PanelMeetDotmeetSessionsIndexRoute;
  "/_panel/_news/news/categories/": typeof PanelNewsDotnewsCategoriesIndexRoute;
  "/_panel/_performance/performance/checkins/": typeof PanelPerformanceDotperformanceCheckinsIndexRoute;
  "/_panel/_performance/performance/objectives/": typeof PanelPerformanceDotperformanceObjectivesIndexRoute;
  "/_panel/_performance/performance/reviews/": typeof PanelPerformanceDotperformanceReviewsIndexRoute;
  "/_panel/_recognition/recognition/rewards/": typeof PanelRecognitionDotrecognitionRewardsIndexRoute;
  "/_panel/_recognition/recognition/top/": typeof PanelRecognitionDotrecognitionTopIndexRoute;
  "/admin/_panel/_chart/chart/": typeof AdminPanelChartDotchartIndexRoute;
  "/admin/_panel/_handbook/handbook/": typeof AdminPanelHandbookDothandbookIndexRoute;
  "/admin/_panel/_mood/mood/": typeof AdminPanelMoodDotmoodIndexRoute;
  "/admin/_panel/_news/news/": typeof AdminPanelNewsDotnewsIndexRoute;
  "/admin/_panel/_profile/profile/": typeof AdminPanelProfileDotprofileIndexRoute;
  "/admin/_panel/_settings/settings/": typeof AdminPanelSettingsDotsettingsIndexRoute;
  "/_panel/_application/application/applications/$id/request": typeof PanelApplicationDotapplicationApplicationsIdRequestRoute;
  "/_panel/_messenger/messenger/groups/join/$token": typeof PanelMessengerDotmessengerGroupsJoinTokenRoute;
  "/_panel/_performance/performance/objectives/edit/$id": typeof PanelPerformanceDotperformanceObjectivesEditIdRoute;
  "/admin/_panel/_application/application/applications/$id": typeof AdminPanelApplicationDotapplicationApplicationsIdRoute;
  "/admin/_panel/_application/application/applications/create": typeof AdminPanelApplicationDotapplicationApplicationsCreateRoute;
  "/admin/_panel/_handbook/handbook/entries/$entry": typeof AdminPanelHandbookDothandbookEntriesEntryRoute;
  "/admin/_panel/_handbook/handbook/entries/create": typeof AdminPanelHandbookDothandbookEntriesCreateRoute;
  "/admin/_panel/_recognition/recognition/period-reports/$id": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute;
  "/admin/_panel/_recognition/recognition/transactions/rewards": typeof AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute;
  "/admin/_panel/_report/report/reports/$id": typeof AdminPanelReportDotreportReportsIdRoute;
  "/admin/_panel/_report/report/reports/create": typeof AdminPanelReportDotreportReportsCreateRoute;
  "/admin/_panel/_settings/settings/entity/$id": typeof AdminPanelSettingsDotsettingsEntityIdRoute;
  "/admin/_panel/_settings/settings/entity/create": typeof AdminPanelSettingsDotsettingsEntityCreateRoute;
  "/admin/_panel/_settings/settings/roles/$id": typeof AdminPanelSettingsDotsettingsRolesIdRoute;
  "/admin/_panel/_settings/settings/roles/create": typeof AdminPanelSettingsDotsettingsRolesCreateRoute;
  "/admin/_panel/_application/application/applications/": typeof AdminPanelApplicationDotapplicationApplicationsIndexRoute;
  "/admin/_panel/_application/application/categories/": typeof AdminPanelApplicationDotapplicationCategoriesIndexRoute;
  "/admin/_panel/_handbook/handbook/categories/": typeof AdminPanelHandbookDothandbookCategoriesIndexRoute;
  "/admin/_panel/_handbook/handbook/entries/": typeof AdminPanelHandbookDothandbookEntriesIndexRoute;
  "/admin/_panel/_messenger/messenger/groups/": typeof AdminPanelMessengerDotmessengerGroupsIndexRoute;
  "/admin/_panel/_news/news/categories/": typeof AdminPanelNewsDotnewsCategoriesIndexRoute;
  "/admin/_panel/_news/news/comments/": typeof AdminPanelNewsDotnewsCommentsIndexRoute;
  "/admin/_panel/_performance/performance/tags/": typeof AdminPanelPerformanceDotperformanceTagsIndexRoute;
  "/admin/_panel/_recognition/recognition/period-reports/": typeof AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute;
  "/admin/_panel/_recognition/recognition/periods/": typeof AdminPanelRecognitionDotrecognitionPeriodsIndexRoute;
  "/admin/_panel/_recognition/recognition/rewards/": typeof AdminPanelRecognitionDotrecognitionRewardsIndexRoute;
  "/admin/_panel/_recognition/recognition/transactions/": typeof AdminPanelRecognitionDotrecognitionTransactionsIndexRoute;
  "/admin/_panel/_recognition/recognition/values/": typeof AdminPanelRecognitionDotrecognitionValuesIndexRoute;
  "/admin/_panel/_report/report/reports/": typeof AdminPanelReportDotreportReportsIndexRoute;
  "/admin/_panel/_settings/settings/entity/": typeof AdminPanelSettingsDotsettingsEntityIndexRoute;
  "/admin/_panel/_settings/settings/roles/": typeof AdminPanelSettingsDotsettingsRolesIndexRoute;
  "/admin/_panel/_performance/performance/checkins-meetings/forms/$id": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute;
  "/admin/_panel/_performance/performance/checkins-meetings/forms/create": typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute;
  "/admin/_panel/_performance/performance/objectives/periods/create": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute;
  "/admin/_panel/_performance/performance/reviews/forms/$id": typeof AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute;
  "/admin/_panel/_performance/performance/reviews/forms/create": typeof AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute;
  "/admin/_panel/_performance/performance/reviews/periods/create": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute;
  "/admin/_panel/_report/report/reports/view/$id": typeof AdminPanelReportDotreportReportsViewIdRoute;
  "/admin/_panel/_chart/chart/$type/positions/": typeof AdminPanelChartDotchartTypePositionsIndexRoute;
  "/admin/_panel/_chart/chart/$type/units/": typeof AdminPanelChartDotchartTypeUnitsIndexRoute;
  "/admin/_panel/_performance/performance/objectives/periods/": typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute;
  "/admin/_panel/_performance/performance/reviews/periods/": typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/login"
    | "/admin"
    | "/meet/$code"
    | "/"
    | "/messenger/$id"
    | "/news/$id"
    | "/profile/$id"
    | "/profile/me"
    | "/settings/locale"
    | "/settings/notifications"
    | "/application/requests/uuid/$uuid"
    | "/messenger"
    | "/news"
    | "/performance"
    | "/recognition"
    | "/settings"
    | "/admin/"
    | "/application/requests/$id"
    | "/chart/charts/$type"
    | "/handbook/entries/$id"
    | "/performance/checkins/$id"
    | "/performance/checkins/create"
    | "/performance/objectives/$id"
    | "/performance/objectives/create"
    | "/recognition/top/$id"
    | "/recognition/transactions/rewards"
    | "/recognition/transactions/transfers"
    | "/admin/chart/$type"
    | "/admin/news/$id"
    | "/admin/news/create"
    | "/admin/profile/requests"
    | "/admin/settings/mood"
    | "/admin/settings/news"
    | "/admin/settings/notifications"
    | "/admin/settings/performance"
    | "/admin/settings/profile"
    | "/admin/settings/recognition"
    | "/admin/settings/users"
    | "/application/applications"
    | "/application/requests"
    | "/handbook/entries"
    | "/meet/sessions"
    | "/news/categories"
    | "/performance/checkins"
    | "/performance/objectives"
    | "/performance/reviews"
    | "/recognition/rewards"
    | "/recognition/top"
    | "/admin/chart"
    | "/admin/handbook"
    | "/admin/mood"
    | "/admin/news"
    | "/admin/profile"
    | "/admin/settings"
    | "/application/applications/$id/request"
    | "/messenger/groups/join/$token"
    | "/performance/objectives/edit/$id"
    | "/admin/application/applications/$id"
    | "/admin/application/applications/create"
    | "/admin/handbook/entries/$entry"
    | "/admin/handbook/entries/create"
    | "/admin/recognition/period-reports/$id"
    | "/admin/recognition/transactions/rewards"
    | "/admin/report/reports/$id"
    | "/admin/report/reports/create"
    | "/admin/settings/entity/$id"
    | "/admin/settings/entity/create"
    | "/admin/settings/roles/$id"
    | "/admin/settings/roles/create"
    | "/admin/application/applications"
    | "/admin/application/categories"
    | "/admin/handbook/categories"
    | "/admin/handbook/entries"
    | "/admin/messenger/groups"
    | "/admin/news/categories"
    | "/admin/news/comments"
    | "/admin/performance/tags"
    | "/admin/recognition/period-reports"
    | "/admin/recognition/periods"
    | "/admin/recognition/rewards"
    | "/admin/recognition/transactions"
    | "/admin/recognition/values"
    | "/admin/report/reports"
    | "/admin/settings/entity"
    | "/admin/settings/roles"
    | "/admin/performance/checkins-meetings/forms/$id"
    | "/admin/performance/checkins-meetings/forms/create"
    | "/admin/performance/objectives/periods/create"
    | "/admin/performance/reviews/forms/$id"
    | "/admin/performance/reviews/forms/create"
    | "/admin/performance/reviews/periods/create"
    | "/admin/report/reports/view/$id"
    | "/admin/chart/$type/positions"
    | "/admin/chart/$type/units"
    | "/admin/performance/objectives/periods"
    | "/admin/performance/reviews/periods";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/login"
    | "/admin"
    | "/meet/$code"
    | "/"
    | "/messenger/$id"
    | "/news/$id"
    | "/profile/$id"
    | "/profile/me"
    | "/settings/locale"
    | "/settings/notifications"
    | "/application/requests/uuid/$uuid"
    | "/messenger"
    | "/news"
    | "/performance"
    | "/recognition"
    | "/settings"
    | "/application/requests/$id"
    | "/chart/charts/$type"
    | "/handbook/entries/$id"
    | "/performance/checkins/$id"
    | "/performance/checkins/create"
    | "/performance/objectives/$id"
    | "/performance/objectives/create"
    | "/recognition/top/$id"
    | "/recognition/transactions/rewards"
    | "/recognition/transactions/transfers"
    | "/admin/chart/$type"
    | "/admin/news/$id"
    | "/admin/news/create"
    | "/admin/profile/requests"
    | "/admin/settings/mood"
    | "/admin/settings/news"
    | "/admin/settings/notifications"
    | "/admin/settings/performance"
    | "/admin/settings/profile"
    | "/admin/settings/recognition"
    | "/admin/settings/users"
    | "/application/applications"
    | "/application/requests"
    | "/handbook/entries"
    | "/meet/sessions"
    | "/news/categories"
    | "/performance/checkins"
    | "/performance/objectives"
    | "/performance/reviews"
    | "/recognition/rewards"
    | "/recognition/top"
    | "/admin/chart"
    | "/admin/handbook"
    | "/admin/mood"
    | "/admin/news"
    | "/admin/profile"
    | "/admin/settings"
    | "/application/applications/$id/request"
    | "/messenger/groups/join/$token"
    | "/performance/objectives/edit/$id"
    | "/admin/application/applications/$id"
    | "/admin/application/applications/create"
    | "/admin/handbook/entries/$entry"
    | "/admin/handbook/entries/create"
    | "/admin/recognition/period-reports/$id"
    | "/admin/recognition/transactions/rewards"
    | "/admin/report/reports/$id"
    | "/admin/report/reports/create"
    | "/admin/settings/entity/$id"
    | "/admin/settings/entity/create"
    | "/admin/settings/roles/$id"
    | "/admin/settings/roles/create"
    | "/admin/application/applications"
    | "/admin/application/categories"
    | "/admin/handbook/categories"
    | "/admin/handbook/entries"
    | "/admin/messenger/groups"
    | "/admin/news/categories"
    | "/admin/news/comments"
    | "/admin/performance/tags"
    | "/admin/recognition/period-reports"
    | "/admin/recognition/periods"
    | "/admin/recognition/rewards"
    | "/admin/recognition/transactions"
    | "/admin/recognition/values"
    | "/admin/report/reports"
    | "/admin/settings/entity"
    | "/admin/settings/roles"
    | "/admin/performance/checkins-meetings/forms/$id"
    | "/admin/performance/checkins-meetings/forms/create"
    | "/admin/performance/objectives/periods/create"
    | "/admin/performance/reviews/forms/$id"
    | "/admin/performance/reviews/forms/create"
    | "/admin/performance/reviews/periods/create"
    | "/admin/report/reports/view/$id"
    | "/admin/chart/$type/positions"
    | "/admin/chart/$type/units"
    | "/admin/performance/objectives/periods"
    | "/admin/performance/reviews/periods";
  id:
    | "__root__"
    | "/_meet"
    | "/_panel"
    | "/login"
    | "/_panel/_application"
    | "/_panel/_chart"
    | "/_panel/_core"
    | "/_panel/_handbook"
    | "/_panel/_meet"
    | "/_panel/_messenger"
    | "/_panel/_news"
    | "/_panel/_performance"
    | "/_panel/_profile"
    | "/_panel/_recognition"
    | "/_panel/_settings"
    | "/admin"
    | "/admin/_panel"
    | "/_meet/meet/$code"
    | "/admin/_panel/_application"
    | "/admin/_panel/_chart"
    | "/admin/_panel/_core"
    | "/admin/_panel/_handbook"
    | "/admin/_panel/_messenger"
    | "/admin/_panel/_mood"
    | "/admin/_panel/_news"
    | "/admin/_panel/_performance"
    | "/admin/_panel/_profile"
    | "/admin/_panel/_recognition"
    | "/admin/_panel/_report"
    | "/admin/_panel/_settings"
    | "/_panel/_core/"
    | "/_panel/_messenger/messenger/$id"
    | "/_panel/_news/news/$id"
    | "/_panel/_profile/profile/$id"
    | "/_panel/_profile/profile/me"
    | "/_panel/_settings/settings/locale"
    | "/_panel/_settings/settings/notifications"
    | "/application/requests/uuid/$uuid"
    | "/_panel/_messenger/messenger/"
    | "/_panel/_news/news/"
    | "/_panel/_performance/performance/"
    | "/_panel/_recognition/recognition/"
    | "/_panel/_settings/settings/"
    | "/admin/_panel/_core/"
    | "/_panel/_application/application/requests/$id"
    | "/_panel/_chart/chart/charts/$type"
    | "/_panel/_handbook/handbook/entries/$id"
    | "/_panel/_performance/performance/checkins/$id"
    | "/_panel/_performance/performance/checkins/create"
    | "/_panel/_performance/performance/objectives/$id"
    | "/_panel/_performance/performance/objectives/create"
    | "/_panel/_recognition/recognition/top/$id"
    | "/_panel/_recognition/recognition/transactions/rewards"
    | "/_panel/_recognition/recognition/transactions/transfers"
    | "/admin/_panel/_chart/chart/$type"
    | "/admin/_panel/_news/news/$id"
    | "/admin/_panel/_news/news/create"
    | "/admin/_panel/_profile/profile/requests"
    | "/admin/_panel/_settings/settings/mood"
    | "/admin/_panel/_settings/settings/news"
    | "/admin/_panel/_settings/settings/notifications"
    | "/admin/_panel/_settings/settings/performance"
    | "/admin/_panel/_settings/settings/profile"
    | "/admin/_panel/_settings/settings/recognition"
    | "/admin/_panel/_settings/settings/users"
    | "/_panel/_application/application/applications/"
    | "/_panel/_application/application/requests/"
    | "/_panel/_handbook/handbook/entries/"
    | "/_panel/_meet/meet/sessions/"
    | "/_panel/_news/news/categories/"
    | "/_panel/_performance/performance/checkins/"
    | "/_panel/_performance/performance/objectives/"
    | "/_panel/_performance/performance/reviews/"
    | "/_panel/_recognition/recognition/rewards/"
    | "/_panel/_recognition/recognition/top/"
    | "/admin/_panel/_chart/chart/"
    | "/admin/_panel/_handbook/handbook/"
    | "/admin/_panel/_mood/mood/"
    | "/admin/_panel/_news/news/"
    | "/admin/_panel/_profile/profile/"
    | "/admin/_panel/_settings/settings/"
    | "/_panel/_application/application/applications/$id/request"
    | "/_panel/_messenger/messenger/groups/join/$token"
    | "/_panel/_performance/performance/objectives/edit/$id"
    | "/admin/_panel/_application/application/applications/$id"
    | "/admin/_panel/_application/application/applications/create"
    | "/admin/_panel/_handbook/handbook/entries/$entry"
    | "/admin/_panel/_handbook/handbook/entries/create"
    | "/admin/_panel/_recognition/recognition/period-reports/$id"
    | "/admin/_panel/_recognition/recognition/transactions/rewards"
    | "/admin/_panel/_report/report/reports/$id"
    | "/admin/_panel/_report/report/reports/create"
    | "/admin/_panel/_settings/settings/entity/$id"
    | "/admin/_panel/_settings/settings/entity/create"
    | "/admin/_panel/_settings/settings/roles/$id"
    | "/admin/_panel/_settings/settings/roles/create"
    | "/admin/_panel/_application/application/applications/"
    | "/admin/_panel/_application/application/categories/"
    | "/admin/_panel/_handbook/handbook/categories/"
    | "/admin/_panel/_handbook/handbook/entries/"
    | "/admin/_panel/_messenger/messenger/groups/"
    | "/admin/_panel/_news/news/categories/"
    | "/admin/_panel/_news/news/comments/"
    | "/admin/_panel/_performance/performance/tags/"
    | "/admin/_panel/_recognition/recognition/period-reports/"
    | "/admin/_panel/_recognition/recognition/periods/"
    | "/admin/_panel/_recognition/recognition/rewards/"
    | "/admin/_panel/_recognition/recognition/transactions/"
    | "/admin/_panel/_recognition/recognition/values/"
    | "/admin/_panel/_report/report/reports/"
    | "/admin/_panel/_settings/settings/entity/"
    | "/admin/_panel/_settings/settings/roles/"
    | "/admin/_panel/_performance/performance/checkins-meetings/forms/$id"
    | "/admin/_panel/_performance/performance/checkins-meetings/forms/create"
    | "/admin/_panel/_performance/performance/objectives/periods/create"
    | "/admin/_panel/_performance/performance/reviews/forms/$id"
    | "/admin/_panel/_performance/performance/reviews/forms/create"
    | "/admin/_panel/_performance/performance/reviews/periods/create"
    | "/admin/_panel/_report/report/reports/view/$id"
    | "/admin/_panel/_chart/chart/$type/positions/"
    | "/admin/_panel/_chart/chart/$type/units/"
    | "/admin/_panel/_performance/performance/objectives/periods/"
    | "/admin/_panel/_performance/performance/reviews/periods/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  MeetRoute: typeof MeetRouteWithChildren;
  PanelRoute: typeof PanelRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  AdminRoute: typeof AdminRouteWithChildren;
  ApplicationDotrequestsDotuuidDotuuidRoute: typeof ApplicationDotrequestsDotuuidDotuuidRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/admin": {
      id: "/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_panel": {
      id: "/_panel";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_meet": {
      id: "/_meet";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof MeetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/_panel": {
      id: "/admin/_panel";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/_panel/_settings": {
      id: "/_panel/_settings";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelSettingsRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_recognition": {
      id: "/_panel/_recognition";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelRecognitionRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_profile": {
      id: "/_panel/_profile";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelProfileRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_performance": {
      id: "/_panel/_performance";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelPerformanceRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_news": {
      id: "/_panel/_news";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelNewsRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_messenger": {
      id: "/_panel/_messenger";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelMessengerRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_meet": {
      id: "/_panel/_meet";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelMeetRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_handbook": {
      id: "/_panel/_handbook";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelHandbookRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_core": {
      id: "/_panel/_core";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelCoreRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_chart": {
      id: "/_panel/_chart";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelChartRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_application": {
      id: "/_panel/_application";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof PanelApplicationRouteImport;
      parentRoute: typeof PanelRoute;
    };
    "/_panel/_core/": {
      id: "/_panel/_core/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof PanelCoreIndexRouteImport;
      parentRoute: typeof PanelCoreRoute;
    };
    "/admin/_panel/_settings": {
      id: "/admin/_panel/_settings";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelSettingsRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_report": {
      id: "/admin/_panel/_report";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelReportRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_recognition": {
      id: "/admin/_panel/_recognition";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelRecognitionRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_profile": {
      id: "/admin/_panel/_profile";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelProfileRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_performance": {
      id: "/admin/_panel/_performance";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelPerformanceRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_news": {
      id: "/admin/_panel/_news";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelNewsRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_mood": {
      id: "/admin/_panel/_mood";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelMoodRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_messenger": {
      id: "/admin/_panel/_messenger";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelMessengerRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_handbook": {
      id: "/admin/_panel/_handbook";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelHandbookRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_core": {
      id: "/admin/_panel/_core";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelCoreRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_chart": {
      id: "/admin/_panel/_chart";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelChartRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/admin/_panel/_application": {
      id: "/admin/_panel/_application";
      path: "";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminPanelApplicationRouteImport;
      parentRoute: typeof AdminPanelRoute;
    };
    "/_meet/meet/$code": {
      id: "/_meet/meet/$code";
      path: "/meet/$code";
      fullPath: "/meet/$code";
      preLoaderRoute: typeof MeetDotmeetCodeRouteImport;
      parentRoute: typeof MeetRoute;
    };
    "/admin/_panel/_core/": {
      id: "/admin/_panel/_core/";
      path: "/";
      fullPath: "/admin/";
      preLoaderRoute: typeof AdminPanelCoreIndexRouteImport;
      parentRoute: typeof AdminPanelCoreRoute;
    };
    "/_panel/_settings/settings/": {
      id: "/_panel/_settings/settings/";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof PanelSettingsDotsettingsIndexRouteImport;
      parentRoute: typeof PanelSettingsRoute;
    };
    "/_panel/_recognition/recognition/": {
      id: "/_panel/_recognition/recognition/";
      path: "/recognition";
      fullPath: "/recognition";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionIndexRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_performance/performance/": {
      id: "/_panel/_performance/performance/";
      path: "/performance";
      fullPath: "/performance";
      preLoaderRoute: typeof PanelPerformanceDotperformanceIndexRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_news/news/": {
      id: "/_panel/_news/news/";
      path: "/news";
      fullPath: "/news";
      preLoaderRoute: typeof PanelNewsDotnewsIndexRouteImport;
      parentRoute: typeof PanelNewsRoute;
    };
    "/_panel/_messenger/messenger/": {
      id: "/_panel/_messenger/messenger/";
      path: "/messenger";
      fullPath: "/messenger";
      preLoaderRoute: typeof PanelMessengerDotmessengerIndexRouteImport;
      parentRoute: typeof PanelMessengerRoute;
    };
    "/application/requests/uuid/$uuid": {
      id: "/application/requests/uuid/$uuid";
      path: "/application/requests/uuid/$uuid";
      fullPath: "/application/requests/uuid/$uuid";
      preLoaderRoute: typeof ApplicationDotrequestsDotuuidDotuuidRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_panel/_settings/settings/notifications": {
      id: "/_panel/_settings/settings/notifications";
      path: "/settings/notifications";
      fullPath: "/settings/notifications";
      preLoaderRoute: typeof PanelSettingsDotsettingsNotificationsRouteImport;
      parentRoute: typeof PanelSettingsRoute;
    };
    "/_panel/_settings/settings/locale": {
      id: "/_panel/_settings/settings/locale";
      path: "/settings/locale";
      fullPath: "/settings/locale";
      preLoaderRoute: typeof PanelSettingsDotsettingsLocaleRouteImport;
      parentRoute: typeof PanelSettingsRoute;
    };
    "/_panel/_profile/profile/me": {
      id: "/_panel/_profile/profile/me";
      path: "/profile/me";
      fullPath: "/profile/me";
      preLoaderRoute: typeof PanelProfileDotprofileMeRouteImport;
      parentRoute: typeof PanelProfileRoute;
    };
    "/_panel/_profile/profile/$id": {
      id: "/_panel/_profile/profile/$id";
      path: "/profile/$id";
      fullPath: "/profile/$id";
      preLoaderRoute: typeof PanelProfileDotprofileIdRouteImport;
      parentRoute: typeof PanelProfileRoute;
    };
    "/_panel/_news/news/$id": {
      id: "/_panel/_news/news/$id";
      path: "/news/$id";
      fullPath: "/news/$id";
      preLoaderRoute: typeof PanelNewsDotnewsIdRouteImport;
      parentRoute: typeof PanelNewsRoute;
    };
    "/_panel/_messenger/messenger/$id": {
      id: "/_panel/_messenger/messenger/$id";
      path: "/messenger/$id";
      fullPath: "/messenger/$id";
      preLoaderRoute: typeof PanelMessengerDotmessengerIdRouteImport;
      parentRoute: typeof PanelMessengerRoute;
    };
    "/admin/_panel/_settings/settings/": {
      id: "/admin/_panel/_settings/settings/";
      path: "/settings";
      fullPath: "/admin/settings";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsIndexRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_profile/profile/": {
      id: "/admin/_panel/_profile/profile/";
      path: "/profile";
      fullPath: "/admin/profile";
      preLoaderRoute: typeof AdminPanelProfileDotprofileIndexRouteImport;
      parentRoute: typeof AdminPanelProfileRoute;
    };
    "/admin/_panel/_news/news/": {
      id: "/admin/_panel/_news/news/";
      path: "/news";
      fullPath: "/admin/news";
      preLoaderRoute: typeof AdminPanelNewsDotnewsIndexRouteImport;
      parentRoute: typeof AdminPanelNewsRoute;
    };
    "/admin/_panel/_mood/mood/": {
      id: "/admin/_panel/_mood/mood/";
      path: "/mood";
      fullPath: "/admin/mood";
      preLoaderRoute: typeof AdminPanelMoodDotmoodIndexRouteImport;
      parentRoute: typeof AdminPanelMoodRoute;
    };
    "/admin/_panel/_handbook/handbook/": {
      id: "/admin/_panel/_handbook/handbook/";
      path: "/handbook";
      fullPath: "/admin/handbook";
      preLoaderRoute: typeof AdminPanelHandbookDothandbookIndexRouteImport;
      parentRoute: typeof AdminPanelHandbookRoute;
    };
    "/admin/_panel/_chart/chart/": {
      id: "/admin/_panel/_chart/chart/";
      path: "/chart";
      fullPath: "/admin/chart";
      preLoaderRoute: typeof AdminPanelChartDotchartIndexRouteImport;
      parentRoute: typeof AdminPanelChartRoute;
    };
    "/_panel/_recognition/recognition/top/": {
      id: "/_panel/_recognition/recognition/top/";
      path: "/recognition/top";
      fullPath: "/recognition/top";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionTopIndexRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_recognition/recognition/rewards/": {
      id: "/_panel/_recognition/recognition/rewards/";
      path: "/recognition/rewards";
      fullPath: "/recognition/rewards";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionRewardsIndexRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_performance/performance/reviews/": {
      id: "/_panel/_performance/performance/reviews/";
      path: "/performance/reviews";
      fullPath: "/performance/reviews";
      preLoaderRoute: typeof PanelPerformanceDotperformanceReviewsIndexRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_performance/performance/objectives/": {
      id: "/_panel/_performance/performance/objectives/";
      path: "/performance/objectives";
      fullPath: "/performance/objectives";
      preLoaderRoute: typeof PanelPerformanceDotperformanceObjectivesIndexRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_performance/performance/checkins/": {
      id: "/_panel/_performance/performance/checkins/";
      path: "/performance/checkins";
      fullPath: "/performance/checkins";
      preLoaderRoute: typeof PanelPerformanceDotperformanceCheckinsIndexRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_news/news/categories/": {
      id: "/_panel/_news/news/categories/";
      path: "/news/categories";
      fullPath: "/news/categories";
      preLoaderRoute: typeof PanelNewsDotnewsCategoriesIndexRouteImport;
      parentRoute: typeof PanelNewsRoute;
    };
    "/_panel/_meet/meet/sessions/": {
      id: "/_panel/_meet/meet/sessions/";
      path: "/meet/sessions";
      fullPath: "/meet/sessions";
      preLoaderRoute: typeof PanelMeetDotmeetSessionsIndexRouteImport;
      parentRoute: typeof PanelMeetRoute;
    };
    "/_panel/_handbook/handbook/entries/": {
      id: "/_panel/_handbook/handbook/entries/";
      path: "/handbook/entries";
      fullPath: "/handbook/entries";
      preLoaderRoute: typeof PanelHandbookDothandbookEntriesIndexRouteImport;
      parentRoute: typeof PanelHandbookRoute;
    };
    "/_panel/_application/application/requests/": {
      id: "/_panel/_application/application/requests/";
      path: "/application/requests";
      fullPath: "/application/requests";
      preLoaderRoute: typeof PanelApplicationDotapplicationRequestsIndexRouteImport;
      parentRoute: typeof PanelApplicationRoute;
    };
    "/_panel/_application/application/applications/": {
      id: "/_panel/_application/application/applications/";
      path: "/application/applications";
      fullPath: "/application/applications";
      preLoaderRoute: typeof PanelApplicationDotapplicationApplicationsIndexRouteImport;
      parentRoute: typeof PanelApplicationRoute;
    };
    "/admin/_panel/_settings/settings/users": {
      id: "/admin/_panel/_settings/settings/users";
      path: "/settings/users";
      fullPath: "/admin/settings/users";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsUsersRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/recognition": {
      id: "/admin/_panel/_settings/settings/recognition";
      path: "/settings/recognition";
      fullPath: "/admin/settings/recognition";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsRecognitionRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/profile": {
      id: "/admin/_panel/_settings/settings/profile";
      path: "/settings/profile";
      fullPath: "/admin/settings/profile";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsProfileRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/performance": {
      id: "/admin/_panel/_settings/settings/performance";
      path: "/settings/performance";
      fullPath: "/admin/settings/performance";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsPerformanceRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/notifications": {
      id: "/admin/_panel/_settings/settings/notifications";
      path: "/settings/notifications";
      fullPath: "/admin/settings/notifications";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsNotificationsRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/news": {
      id: "/admin/_panel/_settings/settings/news";
      path: "/settings/news";
      fullPath: "/admin/settings/news";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsNewsRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/mood": {
      id: "/admin/_panel/_settings/settings/mood";
      path: "/settings/mood";
      fullPath: "/admin/settings/mood";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsMoodRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_profile/profile/requests": {
      id: "/admin/_panel/_profile/profile/requests";
      path: "/profile/requests";
      fullPath: "/admin/profile/requests";
      preLoaderRoute: typeof AdminPanelProfileDotprofileRequestsRouteImport;
      parentRoute: typeof AdminPanelProfileRoute;
    };
    "/admin/_panel/_news/news/create": {
      id: "/admin/_panel/_news/news/create";
      path: "/news/create";
      fullPath: "/admin/news/create";
      preLoaderRoute: typeof AdminPanelNewsDotnewsCreateRouteImport;
      parentRoute: typeof AdminPanelNewsRoute;
    };
    "/admin/_panel/_news/news/$id": {
      id: "/admin/_panel/_news/news/$id";
      path: "/news/$id";
      fullPath: "/admin/news/$id";
      preLoaderRoute: typeof AdminPanelNewsDotnewsIdRouteImport;
      parentRoute: typeof AdminPanelNewsRoute;
    };
    "/admin/_panel/_chart/chart/$type": {
      id: "/admin/_panel/_chart/chart/$type";
      path: "/chart/$type";
      fullPath: "/admin/chart/$type";
      preLoaderRoute: typeof AdminPanelChartDotchartTypeRouteImport;
      parentRoute: typeof AdminPanelChartRoute;
    };
    "/_panel/_recognition/recognition/transactions/transfers": {
      id: "/_panel/_recognition/recognition/transactions/transfers";
      path: "/recognition/transactions/transfers";
      fullPath: "/recognition/transactions/transfers";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionTransactionsTransfersRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_recognition/recognition/transactions/rewards": {
      id: "/_panel/_recognition/recognition/transactions/rewards";
      path: "/recognition/transactions/rewards";
      fullPath: "/recognition/transactions/rewards";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionTransactionsRewardsRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_recognition/recognition/top/$id": {
      id: "/_panel/_recognition/recognition/top/$id";
      path: "/recognition/top/$id";
      fullPath: "/recognition/top/$id";
      preLoaderRoute: typeof PanelRecognitionDotrecognitionTopIdRouteImport;
      parentRoute: typeof PanelRecognitionRoute;
    };
    "/_panel/_performance/performance/objectives/create": {
      id: "/_panel/_performance/performance/objectives/create";
      path: "/performance/objectives/create";
      fullPath: "/performance/objectives/create";
      preLoaderRoute: typeof PanelPerformanceDotperformanceObjectivesCreateRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_performance/performance/objectives/$id": {
      id: "/_panel/_performance/performance/objectives/$id";
      path: "/performance/objectives/$id";
      fullPath: "/performance/objectives/$id";
      preLoaderRoute: typeof PanelPerformanceDotperformanceObjectivesIdRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_performance/performance/checkins/create": {
      id: "/_panel/_performance/performance/checkins/create";
      path: "/performance/checkins/create";
      fullPath: "/performance/checkins/create";
      preLoaderRoute: typeof PanelPerformanceDotperformanceCheckinsCreateRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_performance/performance/checkins/$id": {
      id: "/_panel/_performance/performance/checkins/$id";
      path: "/performance/checkins/$id";
      fullPath: "/performance/checkins/$id";
      preLoaderRoute: typeof PanelPerformanceDotperformanceCheckinsIdRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_handbook/handbook/entries/$id": {
      id: "/_panel/_handbook/handbook/entries/$id";
      path: "/handbook/entries/$id";
      fullPath: "/handbook/entries/$id";
      preLoaderRoute: typeof PanelHandbookDothandbookEntriesIdRouteImport;
      parentRoute: typeof PanelHandbookRoute;
    };
    "/_panel/_chart/chart/charts/$type": {
      id: "/_panel/_chart/chart/charts/$type";
      path: "/chart/charts/$type";
      fullPath: "/chart/charts/$type";
      preLoaderRoute: typeof PanelChartDotchartChartsTypeRouteImport;
      parentRoute: typeof PanelChartRoute;
    };
    "/_panel/_application/application/requests/$id": {
      id: "/_panel/_application/application/requests/$id";
      path: "/application/requests/$id";
      fullPath: "/application/requests/$id";
      preLoaderRoute: typeof PanelApplicationDotapplicationRequestsIdRouteImport;
      parentRoute: typeof PanelApplicationRoute;
    };
    "/admin/_panel/_settings/settings/roles/": {
      id: "/admin/_panel/_settings/settings/roles/";
      path: "/settings/roles";
      fullPath: "/admin/settings/roles";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsRolesIndexRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/entity/": {
      id: "/admin/_panel/_settings/settings/entity/";
      path: "/settings/entity";
      fullPath: "/admin/settings/entity";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsEntityIndexRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_report/report/reports/": {
      id: "/admin/_panel/_report/report/reports/";
      path: "/report/reports";
      fullPath: "/admin/report/reports";
      preLoaderRoute: typeof AdminPanelReportDotreportReportsIndexRouteImport;
      parentRoute: typeof AdminPanelReportRoute;
    };
    "/admin/_panel/_recognition/recognition/values/": {
      id: "/admin/_panel/_recognition/recognition/values/";
      path: "/recognition/values";
      fullPath: "/admin/recognition/values";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionValuesIndexRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_recognition/recognition/transactions/": {
      id: "/admin/_panel/_recognition/recognition/transactions/";
      path: "/recognition/transactions";
      fullPath: "/admin/recognition/transactions";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionTransactionsIndexRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_recognition/recognition/rewards/": {
      id: "/admin/_panel/_recognition/recognition/rewards/";
      path: "/recognition/rewards";
      fullPath: "/admin/recognition/rewards";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionRewardsIndexRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_recognition/recognition/periods/": {
      id: "/admin/_panel/_recognition/recognition/periods/";
      path: "/recognition/periods";
      fullPath: "/admin/recognition/periods";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionPeriodsIndexRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_recognition/recognition/period-reports/": {
      id: "/admin/_panel/_recognition/recognition/period-reports/";
      path: "/recognition/period-reports";
      fullPath: "/admin/recognition/period-reports";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionPeriodReportsIndexRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_performance/performance/tags/": {
      id: "/admin/_panel/_performance/performance/tags/";
      path: "/performance/tags";
      fullPath: "/admin/performance/tags";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceTagsIndexRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_news/news/comments/": {
      id: "/admin/_panel/_news/news/comments/";
      path: "/news/comments";
      fullPath: "/admin/news/comments";
      preLoaderRoute: typeof AdminPanelNewsDotnewsCommentsIndexRouteImport;
      parentRoute: typeof AdminPanelNewsRoute;
    };
    "/admin/_panel/_news/news/categories/": {
      id: "/admin/_panel/_news/news/categories/";
      path: "/news/categories";
      fullPath: "/admin/news/categories";
      preLoaderRoute: typeof AdminPanelNewsDotnewsCategoriesIndexRouteImport;
      parentRoute: typeof AdminPanelNewsRoute;
    };
    "/admin/_panel/_messenger/messenger/groups/": {
      id: "/admin/_panel/_messenger/messenger/groups/";
      path: "/messenger/groups";
      fullPath: "/admin/messenger/groups";
      preLoaderRoute: typeof AdminPanelMessengerDotmessengerGroupsIndexRouteImport;
      parentRoute: typeof AdminPanelMessengerRoute;
    };
    "/admin/_panel/_handbook/handbook/entries/": {
      id: "/admin/_panel/_handbook/handbook/entries/";
      path: "/handbook/entries";
      fullPath: "/admin/handbook/entries";
      preLoaderRoute: typeof AdminPanelHandbookDothandbookEntriesIndexRouteImport;
      parentRoute: typeof AdminPanelHandbookRoute;
    };
    "/admin/_panel/_handbook/handbook/categories/": {
      id: "/admin/_panel/_handbook/handbook/categories/";
      path: "/handbook/categories";
      fullPath: "/admin/handbook/categories";
      preLoaderRoute: typeof AdminPanelHandbookDothandbookCategoriesIndexRouteImport;
      parentRoute: typeof AdminPanelHandbookRoute;
    };
    "/admin/_panel/_application/application/categories/": {
      id: "/admin/_panel/_application/application/categories/";
      path: "/application/categories";
      fullPath: "/admin/application/categories";
      preLoaderRoute: typeof AdminPanelApplicationDotapplicationCategoriesIndexRouteImport;
      parentRoute: typeof AdminPanelApplicationRoute;
    };
    "/admin/_panel/_application/application/applications/": {
      id: "/admin/_panel/_application/application/applications/";
      path: "/application/applications";
      fullPath: "/admin/application/applications";
      preLoaderRoute: typeof AdminPanelApplicationDotapplicationApplicationsIndexRouteImport;
      parentRoute: typeof AdminPanelApplicationRoute;
    };
    "/admin/_panel/_settings/settings/roles/create": {
      id: "/admin/_panel/_settings/settings/roles/create";
      path: "/settings/roles/create";
      fullPath: "/admin/settings/roles/create";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsRolesCreateRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/roles/$id": {
      id: "/admin/_panel/_settings/settings/roles/$id";
      path: "/settings/roles/$id";
      fullPath: "/admin/settings/roles/$id";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsRolesIdRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/entity/create": {
      id: "/admin/_panel/_settings/settings/entity/create";
      path: "/settings/entity/create";
      fullPath: "/admin/settings/entity/create";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsEntityCreateRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_settings/settings/entity/$id": {
      id: "/admin/_panel/_settings/settings/entity/$id";
      path: "/settings/entity/$id";
      fullPath: "/admin/settings/entity/$id";
      preLoaderRoute: typeof AdminPanelSettingsDotsettingsEntityIdRouteImport;
      parentRoute: typeof AdminPanelSettingsRoute;
    };
    "/admin/_panel/_report/report/reports/create": {
      id: "/admin/_panel/_report/report/reports/create";
      path: "/report/reports/create";
      fullPath: "/admin/report/reports/create";
      preLoaderRoute: typeof AdminPanelReportDotreportReportsCreateRouteImport;
      parentRoute: typeof AdminPanelReportRoute;
    };
    "/admin/_panel/_report/report/reports/$id": {
      id: "/admin/_panel/_report/report/reports/$id";
      path: "/report/reports/$id";
      fullPath: "/admin/report/reports/$id";
      preLoaderRoute: typeof AdminPanelReportDotreportReportsIdRouteImport;
      parentRoute: typeof AdminPanelReportRoute;
    };
    "/admin/_panel/_recognition/recognition/transactions/rewards": {
      id: "/admin/_panel/_recognition/recognition/transactions/rewards";
      path: "/recognition/transactions/rewards";
      fullPath: "/admin/recognition/transactions/rewards";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionTransactionsRewardsRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_recognition/recognition/period-reports/$id": {
      id: "/admin/_panel/_recognition/recognition/period-reports/$id";
      path: "/recognition/period-reports/$id";
      fullPath: "/admin/recognition/period-reports/$id";
      preLoaderRoute: typeof AdminPanelRecognitionDotrecognitionPeriodReportsIdRouteImport;
      parentRoute: typeof AdminPanelRecognitionRoute;
    };
    "/admin/_panel/_handbook/handbook/entries/create": {
      id: "/admin/_panel/_handbook/handbook/entries/create";
      path: "/handbook/entries/create";
      fullPath: "/admin/handbook/entries/create";
      preLoaderRoute: typeof AdminPanelHandbookDothandbookEntriesCreateRouteImport;
      parentRoute: typeof AdminPanelHandbookRoute;
    };
    "/admin/_panel/_handbook/handbook/entries/$entry": {
      id: "/admin/_panel/_handbook/handbook/entries/$entry";
      path: "/handbook/entries/$entry";
      fullPath: "/admin/handbook/entries/$entry";
      preLoaderRoute: typeof AdminPanelHandbookDothandbookEntriesEntryRouteImport;
      parentRoute: typeof AdminPanelHandbookRoute;
    };
    "/admin/_panel/_application/application/applications/create": {
      id: "/admin/_panel/_application/application/applications/create";
      path: "/application/applications/create";
      fullPath: "/admin/application/applications/create";
      preLoaderRoute: typeof AdminPanelApplicationDotapplicationApplicationsCreateRouteImport;
      parentRoute: typeof AdminPanelApplicationRoute;
    };
    "/admin/_panel/_application/application/applications/$id": {
      id: "/admin/_panel/_application/application/applications/$id";
      path: "/application/applications/$id";
      fullPath: "/admin/application/applications/$id";
      preLoaderRoute: typeof AdminPanelApplicationDotapplicationApplicationsIdRouteImport;
      parentRoute: typeof AdminPanelApplicationRoute;
    };
    "/_panel/_performance/performance/objectives/edit/$id": {
      id: "/_panel/_performance/performance/objectives/edit/$id";
      path: "/performance/objectives/edit/$id";
      fullPath: "/performance/objectives/edit/$id";
      preLoaderRoute: typeof PanelPerformanceDotperformanceObjectivesEditIdRouteImport;
      parentRoute: typeof PanelPerformanceRoute;
    };
    "/_panel/_messenger/messenger/groups/join/$token": {
      id: "/_panel/_messenger/messenger/groups/join/$token";
      path: "/messenger/groups/join/$token";
      fullPath: "/messenger/groups/join/$token";
      preLoaderRoute: typeof PanelMessengerDotmessengerGroupsJoinTokenRouteImport;
      parentRoute: typeof PanelMessengerRoute;
    };
    "/_panel/_application/application/applications/$id/request": {
      id: "/_panel/_application/application/applications/$id/request";
      path: "/application/applications/$id/request";
      fullPath: "/application/applications/$id/request";
      preLoaderRoute: typeof PanelApplicationDotapplicationApplicationsIdRequestRouteImport;
      parentRoute: typeof PanelApplicationRoute;
    };
    "/admin/_panel/_performance/performance/reviews/periods/": {
      id: "/admin/_panel/_performance/performance/reviews/periods/";
      path: "/performance/reviews/periods";
      fullPath: "/admin/performance/reviews/periods";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/objectives/periods/": {
      id: "/admin/_panel/_performance/performance/objectives/periods/";
      path: "/performance/objectives/periods";
      fullPath: "/admin/performance/objectives/periods";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_chart/chart/$type/units/": {
      id: "/admin/_panel/_chart/chart/$type/units/";
      path: "/units";
      fullPath: "/admin/chart/$type/units";
      preLoaderRoute: typeof AdminPanelChartDotchartTypeUnitsIndexRouteImport;
      parentRoute: typeof AdminPanelChartDotchartTypeRoute;
    };
    "/admin/_panel/_chart/chart/$type/positions/": {
      id: "/admin/_panel/_chart/chart/$type/positions/";
      path: "/positions";
      fullPath: "/admin/chart/$type/positions";
      preLoaderRoute: typeof AdminPanelChartDotchartTypePositionsIndexRouteImport;
      parentRoute: typeof AdminPanelChartDotchartTypeRoute;
    };
    "/admin/_panel/_report/report/reports/view/$id": {
      id: "/admin/_panel/_report/report/reports/view/$id";
      path: "/report/reports/view/$id";
      fullPath: "/admin/report/reports/view/$id";
      preLoaderRoute: typeof AdminPanelReportDotreportReportsViewIdRouteImport;
      parentRoute: typeof AdminPanelReportRoute;
    };
    "/admin/_panel/_performance/performance/reviews/periods/create": {
      id: "/admin/_panel/_performance/performance/reviews/periods/create";
      path: "/performance/reviews/periods/create";
      fullPath: "/admin/performance/reviews/periods/create";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/reviews/forms/create": {
      id: "/admin/_panel/_performance/performance/reviews/forms/create";
      path: "/performance/reviews/forms/create";
      fullPath: "/admin/performance/reviews/forms/create";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotformsCreateRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/reviews/forms/$id": {
      id: "/admin/_panel/_performance/performance/reviews/forms/$id";
      path: "/performance/reviews/forms/$id";
      fullPath: "/admin/performance/reviews/forms/$id";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotformsIdRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/objectives/periods/create": {
      id: "/admin/_panel/_performance/performance/objectives/periods/create";
      path: "/performance/objectives/periods/create";
      fullPath: "/admin/performance/objectives/periods/create";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/checkins-meetings/forms/create": {
      id: "/admin/_panel/_performance/performance/checkins-meetings/forms/create";
      path: "/performance/checkins-meetings/forms/create";
      fullPath: "/admin/performance/checkins-meetings/forms/create";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
    "/admin/_panel/_performance/performance/checkins-meetings/forms/$id": {
      id: "/admin/_panel/_performance/performance/checkins-meetings/forms/$id";
      path: "/performance/checkins-meetings/forms/$id";
      fullPath: "/admin/performance/checkins-meetings/forms/$id";
      preLoaderRoute: typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRouteImport;
      parentRoute: typeof AdminPanelPerformanceRoute;
    };
  }
}

interface MeetRouteChildren {
  MeetDotmeetCodeRoute: typeof MeetDotmeetCodeRoute;
}

const MeetRouteChildren: MeetRouteChildren = {
  MeetDotmeetCodeRoute: MeetDotmeetCodeRoute,
};

const MeetRouteWithChildren = MeetRoute._addFileChildren(MeetRouteChildren);

interface PanelApplicationRouteChildren {
  PanelApplicationDotapplicationRequestsIdRoute: typeof PanelApplicationDotapplicationRequestsIdRoute;
  PanelApplicationDotapplicationApplicationsIndexRoute: typeof PanelApplicationDotapplicationApplicationsIndexRoute;
  PanelApplicationDotapplicationRequestsIndexRoute: typeof PanelApplicationDotapplicationRequestsIndexRoute;
  PanelApplicationDotapplicationApplicationsIdRequestRoute: typeof PanelApplicationDotapplicationApplicationsIdRequestRoute;
}

const PanelApplicationRouteChildren: PanelApplicationRouteChildren = {
  PanelApplicationDotapplicationRequestsIdRoute:
    PanelApplicationDotapplicationRequestsIdRoute,
  PanelApplicationDotapplicationApplicationsIndexRoute:
    PanelApplicationDotapplicationApplicationsIndexRoute,
  PanelApplicationDotapplicationRequestsIndexRoute:
    PanelApplicationDotapplicationRequestsIndexRoute,
  PanelApplicationDotapplicationApplicationsIdRequestRoute:
    PanelApplicationDotapplicationApplicationsIdRequestRoute,
};

const PanelApplicationRouteWithChildren =
  PanelApplicationRoute._addFileChildren(PanelApplicationRouteChildren);

interface PanelChartRouteChildren {
  PanelChartDotchartChartsTypeRoute: typeof PanelChartDotchartChartsTypeRoute;
}

const PanelChartRouteChildren: PanelChartRouteChildren = {
  PanelChartDotchartChartsTypeRoute: PanelChartDotchartChartsTypeRoute,
};

const PanelChartRouteWithChildren = PanelChartRoute._addFileChildren(
  PanelChartRouteChildren,
);

interface PanelCoreRouteChildren {
  PanelCoreIndexRoute: typeof PanelCoreIndexRoute;
}

const PanelCoreRouteChildren: PanelCoreRouteChildren = {
  PanelCoreIndexRoute: PanelCoreIndexRoute,
};

const PanelCoreRouteWithChildren = PanelCoreRoute._addFileChildren(
  PanelCoreRouteChildren,
);

interface PanelHandbookRouteChildren {
  PanelHandbookDothandbookEntriesIdRoute: typeof PanelHandbookDothandbookEntriesIdRoute;
  PanelHandbookDothandbookEntriesIndexRoute: typeof PanelHandbookDothandbookEntriesIndexRoute;
}

const PanelHandbookRouteChildren: PanelHandbookRouteChildren = {
  PanelHandbookDothandbookEntriesIdRoute:
    PanelHandbookDothandbookEntriesIdRoute,
  PanelHandbookDothandbookEntriesIndexRoute:
    PanelHandbookDothandbookEntriesIndexRoute,
};

const PanelHandbookRouteWithChildren = PanelHandbookRoute._addFileChildren(
  PanelHandbookRouteChildren,
);

interface PanelMeetRouteChildren {
  PanelMeetDotmeetSessionsIndexRoute: typeof PanelMeetDotmeetSessionsIndexRoute;
}

const PanelMeetRouteChildren: PanelMeetRouteChildren = {
  PanelMeetDotmeetSessionsIndexRoute: PanelMeetDotmeetSessionsIndexRoute,
};

const PanelMeetRouteWithChildren = PanelMeetRoute._addFileChildren(
  PanelMeetRouteChildren,
);

interface PanelMessengerRouteChildren {
  PanelMessengerDotmessengerIdRoute: typeof PanelMessengerDotmessengerIdRoute;
  PanelMessengerDotmessengerIndexRoute: typeof PanelMessengerDotmessengerIndexRoute;
  PanelMessengerDotmessengerGroupsJoinTokenRoute: typeof PanelMessengerDotmessengerGroupsJoinTokenRoute;
}

const PanelMessengerRouteChildren: PanelMessengerRouteChildren = {
  PanelMessengerDotmessengerIdRoute: PanelMessengerDotmessengerIdRoute,
  PanelMessengerDotmessengerIndexRoute: PanelMessengerDotmessengerIndexRoute,
  PanelMessengerDotmessengerGroupsJoinTokenRoute:
    PanelMessengerDotmessengerGroupsJoinTokenRoute,
};

const PanelMessengerRouteWithChildren = PanelMessengerRoute._addFileChildren(
  PanelMessengerRouteChildren,
);

interface PanelNewsRouteChildren {
  PanelNewsDotnewsIdRoute: typeof PanelNewsDotnewsIdRoute;
  PanelNewsDotnewsIndexRoute: typeof PanelNewsDotnewsIndexRoute;
  PanelNewsDotnewsCategoriesIndexRoute: typeof PanelNewsDotnewsCategoriesIndexRoute;
}

const PanelNewsRouteChildren: PanelNewsRouteChildren = {
  PanelNewsDotnewsIdRoute: PanelNewsDotnewsIdRoute,
  PanelNewsDotnewsIndexRoute: PanelNewsDotnewsIndexRoute,
  PanelNewsDotnewsCategoriesIndexRoute: PanelNewsDotnewsCategoriesIndexRoute,
};

const PanelNewsRouteWithChildren = PanelNewsRoute._addFileChildren(
  PanelNewsRouteChildren,
);

interface PanelPerformanceRouteChildren {
  PanelPerformanceDotperformanceIndexRoute: typeof PanelPerformanceDotperformanceIndexRoute;
  PanelPerformanceDotperformanceCheckinsIdRoute: typeof PanelPerformanceDotperformanceCheckinsIdRoute;
  PanelPerformanceDotperformanceCheckinsCreateRoute: typeof PanelPerformanceDotperformanceCheckinsCreateRoute;
  PanelPerformanceDotperformanceObjectivesIdRoute: typeof PanelPerformanceDotperformanceObjectivesIdRoute;
  PanelPerformanceDotperformanceObjectivesCreateRoute: typeof PanelPerformanceDotperformanceObjectivesCreateRoute;
  PanelPerformanceDotperformanceCheckinsIndexRoute: typeof PanelPerformanceDotperformanceCheckinsIndexRoute;
  PanelPerformanceDotperformanceObjectivesIndexRoute: typeof PanelPerformanceDotperformanceObjectivesIndexRoute;
  PanelPerformanceDotperformanceReviewsIndexRoute: typeof PanelPerformanceDotperformanceReviewsIndexRoute;
  PanelPerformanceDotperformanceObjectivesEditIdRoute: typeof PanelPerformanceDotperformanceObjectivesEditIdRoute;
}

const PanelPerformanceRouteChildren: PanelPerformanceRouteChildren = {
  PanelPerformanceDotperformanceIndexRoute:
    PanelPerformanceDotperformanceIndexRoute,
  PanelPerformanceDotperformanceCheckinsIdRoute:
    PanelPerformanceDotperformanceCheckinsIdRoute,
  PanelPerformanceDotperformanceCheckinsCreateRoute:
    PanelPerformanceDotperformanceCheckinsCreateRoute,
  PanelPerformanceDotperformanceObjectivesIdRoute:
    PanelPerformanceDotperformanceObjectivesIdRoute,
  PanelPerformanceDotperformanceObjectivesCreateRoute:
    PanelPerformanceDotperformanceObjectivesCreateRoute,
  PanelPerformanceDotperformanceCheckinsIndexRoute:
    PanelPerformanceDotperformanceCheckinsIndexRoute,
  PanelPerformanceDotperformanceObjectivesIndexRoute:
    PanelPerformanceDotperformanceObjectivesIndexRoute,
  PanelPerformanceDotperformanceReviewsIndexRoute:
    PanelPerformanceDotperformanceReviewsIndexRoute,
  PanelPerformanceDotperformanceObjectivesEditIdRoute:
    PanelPerformanceDotperformanceObjectivesEditIdRoute,
};

const PanelPerformanceRouteWithChildren =
  PanelPerformanceRoute._addFileChildren(PanelPerformanceRouteChildren);

interface PanelProfileRouteChildren {
  PanelProfileDotprofileIdRoute: typeof PanelProfileDotprofileIdRoute;
  PanelProfileDotprofileMeRoute: typeof PanelProfileDotprofileMeRoute;
}

const PanelProfileRouteChildren: PanelProfileRouteChildren = {
  PanelProfileDotprofileIdRoute: PanelProfileDotprofileIdRoute,
  PanelProfileDotprofileMeRoute: PanelProfileDotprofileMeRoute,
};

const PanelProfileRouteWithChildren = PanelProfileRoute._addFileChildren(
  PanelProfileRouteChildren,
);

interface PanelRecognitionRouteChildren {
  PanelRecognitionDotrecognitionIndexRoute: typeof PanelRecognitionDotrecognitionIndexRoute;
  PanelRecognitionDotrecognitionTopIdRoute: typeof PanelRecognitionDotrecognitionTopIdRoute;
  PanelRecognitionDotrecognitionTransactionsRewardsRoute: typeof PanelRecognitionDotrecognitionTransactionsRewardsRoute;
  PanelRecognitionDotrecognitionTransactionsTransfersRoute: typeof PanelRecognitionDotrecognitionTransactionsTransfersRoute;
  PanelRecognitionDotrecognitionRewardsIndexRoute: typeof PanelRecognitionDotrecognitionRewardsIndexRoute;
  PanelRecognitionDotrecognitionTopIndexRoute: typeof PanelRecognitionDotrecognitionTopIndexRoute;
}

const PanelRecognitionRouteChildren: PanelRecognitionRouteChildren = {
  PanelRecognitionDotrecognitionIndexRoute:
    PanelRecognitionDotrecognitionIndexRoute,
  PanelRecognitionDotrecognitionTopIdRoute:
    PanelRecognitionDotrecognitionTopIdRoute,
  PanelRecognitionDotrecognitionTransactionsRewardsRoute:
    PanelRecognitionDotrecognitionTransactionsRewardsRoute,
  PanelRecognitionDotrecognitionTransactionsTransfersRoute:
    PanelRecognitionDotrecognitionTransactionsTransfersRoute,
  PanelRecognitionDotrecognitionRewardsIndexRoute:
    PanelRecognitionDotrecognitionRewardsIndexRoute,
  PanelRecognitionDotrecognitionTopIndexRoute:
    PanelRecognitionDotrecognitionTopIndexRoute,
};

const PanelRecognitionRouteWithChildren =
  PanelRecognitionRoute._addFileChildren(PanelRecognitionRouteChildren);

interface PanelSettingsRouteChildren {
  PanelSettingsDotsettingsLocaleRoute: typeof PanelSettingsDotsettingsLocaleRoute;
  PanelSettingsDotsettingsNotificationsRoute: typeof PanelSettingsDotsettingsNotificationsRoute;
  PanelSettingsDotsettingsIndexRoute: typeof PanelSettingsDotsettingsIndexRoute;
}

const PanelSettingsRouteChildren: PanelSettingsRouteChildren = {
  PanelSettingsDotsettingsLocaleRoute: PanelSettingsDotsettingsLocaleRoute,
  PanelSettingsDotsettingsNotificationsRoute:
    PanelSettingsDotsettingsNotificationsRoute,
  PanelSettingsDotsettingsIndexRoute: PanelSettingsDotsettingsIndexRoute,
};

const PanelSettingsRouteWithChildren = PanelSettingsRoute._addFileChildren(
  PanelSettingsRouteChildren,
);

interface PanelRouteChildren {
  PanelApplicationRoute: typeof PanelApplicationRouteWithChildren;
  PanelChartRoute: typeof PanelChartRouteWithChildren;
  PanelCoreRoute: typeof PanelCoreRouteWithChildren;
  PanelHandbookRoute: typeof PanelHandbookRouteWithChildren;
  PanelMeetRoute: typeof PanelMeetRouteWithChildren;
  PanelMessengerRoute: typeof PanelMessengerRouteWithChildren;
  PanelNewsRoute: typeof PanelNewsRouteWithChildren;
  PanelPerformanceRoute: typeof PanelPerformanceRouteWithChildren;
  PanelProfileRoute: typeof PanelProfileRouteWithChildren;
  PanelRecognitionRoute: typeof PanelRecognitionRouteWithChildren;
  PanelSettingsRoute: typeof PanelSettingsRouteWithChildren;
}

const PanelRouteChildren: PanelRouteChildren = {
  PanelApplicationRoute: PanelApplicationRouteWithChildren,
  PanelChartRoute: PanelChartRouteWithChildren,
  PanelCoreRoute: PanelCoreRouteWithChildren,
  PanelHandbookRoute: PanelHandbookRouteWithChildren,
  PanelMeetRoute: PanelMeetRouteWithChildren,
  PanelMessengerRoute: PanelMessengerRouteWithChildren,
  PanelNewsRoute: PanelNewsRouteWithChildren,
  PanelPerformanceRoute: PanelPerformanceRouteWithChildren,
  PanelProfileRoute: PanelProfileRouteWithChildren,
  PanelRecognitionRoute: PanelRecognitionRouteWithChildren,
  PanelSettingsRoute: PanelSettingsRouteWithChildren,
};

const PanelRouteWithChildren = PanelRoute._addFileChildren(PanelRouteChildren);

interface AdminPanelApplicationRouteChildren {
  AdminPanelApplicationDotapplicationApplicationsIdRoute: typeof AdminPanelApplicationDotapplicationApplicationsIdRoute;
  AdminPanelApplicationDotapplicationApplicationsCreateRoute: typeof AdminPanelApplicationDotapplicationApplicationsCreateRoute;
  AdminPanelApplicationDotapplicationApplicationsIndexRoute: typeof AdminPanelApplicationDotapplicationApplicationsIndexRoute;
  AdminPanelApplicationDotapplicationCategoriesIndexRoute: typeof AdminPanelApplicationDotapplicationCategoriesIndexRoute;
}

const AdminPanelApplicationRouteChildren: AdminPanelApplicationRouteChildren = {
  AdminPanelApplicationDotapplicationApplicationsIdRoute:
    AdminPanelApplicationDotapplicationApplicationsIdRoute,
  AdminPanelApplicationDotapplicationApplicationsCreateRoute:
    AdminPanelApplicationDotapplicationApplicationsCreateRoute,
  AdminPanelApplicationDotapplicationApplicationsIndexRoute:
    AdminPanelApplicationDotapplicationApplicationsIndexRoute,
  AdminPanelApplicationDotapplicationCategoriesIndexRoute:
    AdminPanelApplicationDotapplicationCategoriesIndexRoute,
};

const AdminPanelApplicationRouteWithChildren =
  AdminPanelApplicationRoute._addFileChildren(
    AdminPanelApplicationRouteChildren,
  );

interface AdminPanelChartDotchartTypeRouteChildren {
  AdminPanelChartDotchartTypePositionsIndexRoute: typeof AdminPanelChartDotchartTypePositionsIndexRoute;
  AdminPanelChartDotchartTypeUnitsIndexRoute: typeof AdminPanelChartDotchartTypeUnitsIndexRoute;
}

const AdminPanelChartDotchartTypeRouteChildren: AdminPanelChartDotchartTypeRouteChildren =
  {
    AdminPanelChartDotchartTypePositionsIndexRoute:
      AdminPanelChartDotchartTypePositionsIndexRoute,
    AdminPanelChartDotchartTypeUnitsIndexRoute:
      AdminPanelChartDotchartTypeUnitsIndexRoute,
  };

const AdminPanelChartDotchartTypeRouteWithChildren =
  AdminPanelChartDotchartTypeRoute._addFileChildren(
    AdminPanelChartDotchartTypeRouteChildren,
  );

interface AdminPanelChartRouteChildren {
  AdminPanelChartDotchartTypeRoute: typeof AdminPanelChartDotchartTypeRouteWithChildren;
  AdminPanelChartDotchartIndexRoute: typeof AdminPanelChartDotchartIndexRoute;
}

const AdminPanelChartRouteChildren: AdminPanelChartRouteChildren = {
  AdminPanelChartDotchartTypeRoute:
    AdminPanelChartDotchartTypeRouteWithChildren,
  AdminPanelChartDotchartIndexRoute: AdminPanelChartDotchartIndexRoute,
};

const AdminPanelChartRouteWithChildren = AdminPanelChartRoute._addFileChildren(
  AdminPanelChartRouteChildren,
);

interface AdminPanelCoreRouteChildren {
  AdminPanelCoreIndexRoute: typeof AdminPanelCoreIndexRoute;
}

const AdminPanelCoreRouteChildren: AdminPanelCoreRouteChildren = {
  AdminPanelCoreIndexRoute: AdminPanelCoreIndexRoute,
};

const AdminPanelCoreRouteWithChildren = AdminPanelCoreRoute._addFileChildren(
  AdminPanelCoreRouteChildren,
);

interface AdminPanelHandbookRouteChildren {
  AdminPanelHandbookDothandbookIndexRoute: typeof AdminPanelHandbookDothandbookIndexRoute;
  AdminPanelHandbookDothandbookEntriesEntryRoute: typeof AdminPanelHandbookDothandbookEntriesEntryRoute;
  AdminPanelHandbookDothandbookEntriesCreateRoute: typeof AdminPanelHandbookDothandbookEntriesCreateRoute;
  AdminPanelHandbookDothandbookCategoriesIndexRoute: typeof AdminPanelHandbookDothandbookCategoriesIndexRoute;
  AdminPanelHandbookDothandbookEntriesIndexRoute: typeof AdminPanelHandbookDothandbookEntriesIndexRoute;
}

const AdminPanelHandbookRouteChildren: AdminPanelHandbookRouteChildren = {
  AdminPanelHandbookDothandbookIndexRoute:
    AdminPanelHandbookDothandbookIndexRoute,
  AdminPanelHandbookDothandbookEntriesEntryRoute:
    AdminPanelHandbookDothandbookEntriesEntryRoute,
  AdminPanelHandbookDothandbookEntriesCreateRoute:
    AdminPanelHandbookDothandbookEntriesCreateRoute,
  AdminPanelHandbookDothandbookCategoriesIndexRoute:
    AdminPanelHandbookDothandbookCategoriesIndexRoute,
  AdminPanelHandbookDothandbookEntriesIndexRoute:
    AdminPanelHandbookDothandbookEntriesIndexRoute,
};

const AdminPanelHandbookRouteWithChildren =
  AdminPanelHandbookRoute._addFileChildren(AdminPanelHandbookRouteChildren);

interface AdminPanelMessengerRouteChildren {
  AdminPanelMessengerDotmessengerGroupsIndexRoute: typeof AdminPanelMessengerDotmessengerGroupsIndexRoute;
}

const AdminPanelMessengerRouteChildren: AdminPanelMessengerRouteChildren = {
  AdminPanelMessengerDotmessengerGroupsIndexRoute:
    AdminPanelMessengerDotmessengerGroupsIndexRoute,
};

const AdminPanelMessengerRouteWithChildren =
  AdminPanelMessengerRoute._addFileChildren(AdminPanelMessengerRouteChildren);

interface AdminPanelMoodRouteChildren {
  AdminPanelMoodDotmoodIndexRoute: typeof AdminPanelMoodDotmoodIndexRoute;
}

const AdminPanelMoodRouteChildren: AdminPanelMoodRouteChildren = {
  AdminPanelMoodDotmoodIndexRoute: AdminPanelMoodDotmoodIndexRoute,
};

const AdminPanelMoodRouteWithChildren = AdminPanelMoodRoute._addFileChildren(
  AdminPanelMoodRouteChildren,
);

interface AdminPanelNewsRouteChildren {
  AdminPanelNewsDotnewsIdRoute: typeof AdminPanelNewsDotnewsIdRoute;
  AdminPanelNewsDotnewsCreateRoute: typeof AdminPanelNewsDotnewsCreateRoute;
  AdminPanelNewsDotnewsIndexRoute: typeof AdminPanelNewsDotnewsIndexRoute;
  AdminPanelNewsDotnewsCategoriesIndexRoute: typeof AdminPanelNewsDotnewsCategoriesIndexRoute;
  AdminPanelNewsDotnewsCommentsIndexRoute: typeof AdminPanelNewsDotnewsCommentsIndexRoute;
}

const AdminPanelNewsRouteChildren: AdminPanelNewsRouteChildren = {
  AdminPanelNewsDotnewsIdRoute: AdminPanelNewsDotnewsIdRoute,
  AdminPanelNewsDotnewsCreateRoute: AdminPanelNewsDotnewsCreateRoute,
  AdminPanelNewsDotnewsIndexRoute: AdminPanelNewsDotnewsIndexRoute,
  AdminPanelNewsDotnewsCategoriesIndexRoute:
    AdminPanelNewsDotnewsCategoriesIndexRoute,
  AdminPanelNewsDotnewsCommentsIndexRoute:
    AdminPanelNewsDotnewsCommentsIndexRoute,
};

const AdminPanelNewsRouteWithChildren = AdminPanelNewsRoute._addFileChildren(
  AdminPanelNewsRouteChildren,
);

interface AdminPanelPerformanceRouteChildren {
  AdminPanelPerformanceDotperformanceTagsIndexRoute: typeof AdminPanelPerformanceDotperformanceTagsIndexRoute;
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute: typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute;
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute: typeof AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute;
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute: typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute;
  AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute;
  AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute;
  AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute;
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute: typeof AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute;
  AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute: typeof AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute;
}

const AdminPanelPerformanceRouteChildren: AdminPanelPerformanceRouteChildren = {
  AdminPanelPerformanceDotperformanceTagsIndexRoute:
    AdminPanelPerformanceDotperformanceTagsIndexRoute,
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute:
    AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsIdRoute,
  AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute:
    AdminPanelPerformanceDotperformanceCheckinsMeetingsDotformsCreateRoute,
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute:
    AdminPanelPerformanceDotperformanceObjectivesDotperiodsCreateRoute,
  AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute:
    AdminPanelPerformanceDotperformanceReviewsDotformsIdRoute,
  AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute:
    AdminPanelPerformanceDotperformanceReviewsDotformsCreateRoute,
  AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute:
    AdminPanelPerformanceDotperformanceReviewsDotperiodsCreateRoute,
  AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute:
    AdminPanelPerformanceDotperformanceObjectivesDotperiodsIndexRoute,
  AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute:
    AdminPanelPerformanceDotperformanceReviewsDotperiodsIndexRoute,
};

const AdminPanelPerformanceRouteWithChildren =
  AdminPanelPerformanceRoute._addFileChildren(
    AdminPanelPerformanceRouteChildren,
  );

interface AdminPanelProfileRouteChildren {
  AdminPanelProfileDotprofileRequestsRoute: typeof AdminPanelProfileDotprofileRequestsRoute;
  AdminPanelProfileDotprofileIndexRoute: typeof AdminPanelProfileDotprofileIndexRoute;
}

const AdminPanelProfileRouteChildren: AdminPanelProfileRouteChildren = {
  AdminPanelProfileDotprofileRequestsRoute:
    AdminPanelProfileDotprofileRequestsRoute,
  AdminPanelProfileDotprofileIndexRoute: AdminPanelProfileDotprofileIndexRoute,
};

const AdminPanelProfileRouteWithChildren =
  AdminPanelProfileRoute._addFileChildren(AdminPanelProfileRouteChildren);

interface AdminPanelRecognitionRouteChildren {
  AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute: typeof AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute;
  AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute: typeof AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute;
  AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute: typeof AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute;
  AdminPanelRecognitionDotrecognitionPeriodsIndexRoute: typeof AdminPanelRecognitionDotrecognitionPeriodsIndexRoute;
  AdminPanelRecognitionDotrecognitionRewardsIndexRoute: typeof AdminPanelRecognitionDotrecognitionRewardsIndexRoute;
  AdminPanelRecognitionDotrecognitionTransactionsIndexRoute: typeof AdminPanelRecognitionDotrecognitionTransactionsIndexRoute;
  AdminPanelRecognitionDotrecognitionValuesIndexRoute: typeof AdminPanelRecognitionDotrecognitionValuesIndexRoute;
}

const AdminPanelRecognitionRouteChildren: AdminPanelRecognitionRouteChildren = {
  AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute:
    AdminPanelRecognitionDotrecognitionPeriodReportsIdRoute,
  AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute:
    AdminPanelRecognitionDotrecognitionTransactionsRewardsRoute,
  AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute:
    AdminPanelRecognitionDotrecognitionPeriodReportsIndexRoute,
  AdminPanelRecognitionDotrecognitionPeriodsIndexRoute:
    AdminPanelRecognitionDotrecognitionPeriodsIndexRoute,
  AdminPanelRecognitionDotrecognitionRewardsIndexRoute:
    AdminPanelRecognitionDotrecognitionRewardsIndexRoute,
  AdminPanelRecognitionDotrecognitionTransactionsIndexRoute:
    AdminPanelRecognitionDotrecognitionTransactionsIndexRoute,
  AdminPanelRecognitionDotrecognitionValuesIndexRoute:
    AdminPanelRecognitionDotrecognitionValuesIndexRoute,
};

const AdminPanelRecognitionRouteWithChildren =
  AdminPanelRecognitionRoute._addFileChildren(
    AdminPanelRecognitionRouteChildren,
  );

interface AdminPanelReportRouteChildren {
  AdminPanelReportDotreportReportsIdRoute: typeof AdminPanelReportDotreportReportsIdRoute;
  AdminPanelReportDotreportReportsCreateRoute: typeof AdminPanelReportDotreportReportsCreateRoute;
  AdminPanelReportDotreportReportsIndexRoute: typeof AdminPanelReportDotreportReportsIndexRoute;
  AdminPanelReportDotreportReportsViewIdRoute: typeof AdminPanelReportDotreportReportsViewIdRoute;
}

const AdminPanelReportRouteChildren: AdminPanelReportRouteChildren = {
  AdminPanelReportDotreportReportsIdRoute:
    AdminPanelReportDotreportReportsIdRoute,
  AdminPanelReportDotreportReportsCreateRoute:
    AdminPanelReportDotreportReportsCreateRoute,
  AdminPanelReportDotreportReportsIndexRoute:
    AdminPanelReportDotreportReportsIndexRoute,
  AdminPanelReportDotreportReportsViewIdRoute:
    AdminPanelReportDotreportReportsViewIdRoute,
};

const AdminPanelReportRouteWithChildren =
  AdminPanelReportRoute._addFileChildren(AdminPanelReportRouteChildren);

interface AdminPanelSettingsRouteChildren {
  AdminPanelSettingsDotsettingsMoodRoute: typeof AdminPanelSettingsDotsettingsMoodRoute;
  AdminPanelSettingsDotsettingsNewsRoute: typeof AdminPanelSettingsDotsettingsNewsRoute;
  AdminPanelSettingsDotsettingsNotificationsRoute: typeof AdminPanelSettingsDotsettingsNotificationsRoute;
  AdminPanelSettingsDotsettingsPerformanceRoute: typeof AdminPanelSettingsDotsettingsPerformanceRoute;
  AdminPanelSettingsDotsettingsProfileRoute: typeof AdminPanelSettingsDotsettingsProfileRoute;
  AdminPanelSettingsDotsettingsRecognitionRoute: typeof AdminPanelSettingsDotsettingsRecognitionRoute;
  AdminPanelSettingsDotsettingsUsersRoute: typeof AdminPanelSettingsDotsettingsUsersRoute;
  AdminPanelSettingsDotsettingsIndexRoute: typeof AdminPanelSettingsDotsettingsIndexRoute;
  AdminPanelSettingsDotsettingsEntityIdRoute: typeof AdminPanelSettingsDotsettingsEntityIdRoute;
  AdminPanelSettingsDotsettingsEntityCreateRoute: typeof AdminPanelSettingsDotsettingsEntityCreateRoute;
  AdminPanelSettingsDotsettingsRolesIdRoute: typeof AdminPanelSettingsDotsettingsRolesIdRoute;
  AdminPanelSettingsDotsettingsRolesCreateRoute: typeof AdminPanelSettingsDotsettingsRolesCreateRoute;
  AdminPanelSettingsDotsettingsEntityIndexRoute: typeof AdminPanelSettingsDotsettingsEntityIndexRoute;
  AdminPanelSettingsDotsettingsRolesIndexRoute: typeof AdminPanelSettingsDotsettingsRolesIndexRoute;
}

const AdminPanelSettingsRouteChildren: AdminPanelSettingsRouteChildren = {
  AdminPanelSettingsDotsettingsMoodRoute:
    AdminPanelSettingsDotsettingsMoodRoute,
  AdminPanelSettingsDotsettingsNewsRoute:
    AdminPanelSettingsDotsettingsNewsRoute,
  AdminPanelSettingsDotsettingsNotificationsRoute:
    AdminPanelSettingsDotsettingsNotificationsRoute,
  AdminPanelSettingsDotsettingsPerformanceRoute:
    AdminPanelSettingsDotsettingsPerformanceRoute,
  AdminPanelSettingsDotsettingsProfileRoute:
    AdminPanelSettingsDotsettingsProfileRoute,
  AdminPanelSettingsDotsettingsRecognitionRoute:
    AdminPanelSettingsDotsettingsRecognitionRoute,
  AdminPanelSettingsDotsettingsUsersRoute:
    AdminPanelSettingsDotsettingsUsersRoute,
  AdminPanelSettingsDotsettingsIndexRoute:
    AdminPanelSettingsDotsettingsIndexRoute,
  AdminPanelSettingsDotsettingsEntityIdRoute:
    AdminPanelSettingsDotsettingsEntityIdRoute,
  AdminPanelSettingsDotsettingsEntityCreateRoute:
    AdminPanelSettingsDotsettingsEntityCreateRoute,
  AdminPanelSettingsDotsettingsRolesIdRoute:
    AdminPanelSettingsDotsettingsRolesIdRoute,
  AdminPanelSettingsDotsettingsRolesCreateRoute:
    AdminPanelSettingsDotsettingsRolesCreateRoute,
  AdminPanelSettingsDotsettingsEntityIndexRoute:
    AdminPanelSettingsDotsettingsEntityIndexRoute,
  AdminPanelSettingsDotsettingsRolesIndexRoute:
    AdminPanelSettingsDotsettingsRolesIndexRoute,
};

const AdminPanelSettingsRouteWithChildren =
  AdminPanelSettingsRoute._addFileChildren(AdminPanelSettingsRouteChildren);

interface AdminPanelRouteChildren {
  AdminPanelApplicationRoute: typeof AdminPanelApplicationRouteWithChildren;
  AdminPanelChartRoute: typeof AdminPanelChartRouteWithChildren;
  AdminPanelCoreRoute: typeof AdminPanelCoreRouteWithChildren;
  AdminPanelHandbookRoute: typeof AdminPanelHandbookRouteWithChildren;
  AdminPanelMessengerRoute: typeof AdminPanelMessengerRouteWithChildren;
  AdminPanelMoodRoute: typeof AdminPanelMoodRouteWithChildren;
  AdminPanelNewsRoute: typeof AdminPanelNewsRouteWithChildren;
  AdminPanelPerformanceRoute: typeof AdminPanelPerformanceRouteWithChildren;
  AdminPanelProfileRoute: typeof AdminPanelProfileRouteWithChildren;
  AdminPanelRecognitionRoute: typeof AdminPanelRecognitionRouteWithChildren;
  AdminPanelReportRoute: typeof AdminPanelReportRouteWithChildren;
  AdminPanelSettingsRoute: typeof AdminPanelSettingsRouteWithChildren;
}

const AdminPanelRouteChildren: AdminPanelRouteChildren = {
  AdminPanelApplicationRoute: AdminPanelApplicationRouteWithChildren,
  AdminPanelChartRoute: AdminPanelChartRouteWithChildren,
  AdminPanelCoreRoute: AdminPanelCoreRouteWithChildren,
  AdminPanelHandbookRoute: AdminPanelHandbookRouteWithChildren,
  AdminPanelMessengerRoute: AdminPanelMessengerRouteWithChildren,
  AdminPanelMoodRoute: AdminPanelMoodRouteWithChildren,
  AdminPanelNewsRoute: AdminPanelNewsRouteWithChildren,
  AdminPanelPerformanceRoute: AdminPanelPerformanceRouteWithChildren,
  AdminPanelProfileRoute: AdminPanelProfileRouteWithChildren,
  AdminPanelRecognitionRoute: AdminPanelRecognitionRouteWithChildren,
  AdminPanelReportRoute: AdminPanelReportRouteWithChildren,
  AdminPanelSettingsRoute: AdminPanelSettingsRouteWithChildren,
};

const AdminPanelRouteWithChildren = AdminPanelRoute._addFileChildren(
  AdminPanelRouteChildren,
);

interface AdminRouteChildren {
  AdminPanelRoute: typeof AdminPanelRouteWithChildren;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminPanelRoute: AdminPanelRouteWithChildren,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  MeetRoute: MeetRouteWithChildren,
  PanelRoute: PanelRouteWithChildren,
  LoginRoute: LoginRoute,
  AdminRoute: AdminRouteWithChildren,
  ApplicationDotrequestsDotuuidDotuuidRoute:
    ApplicationDotrequestsDotuuidDotuuidRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
